const facetLabelsMap = {
  "sellingPrice": "Price :",
  "brands": "Brand :",
  "sizes": "Size :",
  "product_width_new": "Width :",
  "product_length_new": "Length :",
  "product_thickness_new": "Thickness :"
};

const colorMap = new Map([
  ["Blacks", "#000000"],
  ["Grays", "#999d9e"],
  ["White", "white"],
  ["Blues", "#2e3cbf"],
  ["Navy", "#2e3cbf"],
  ["Greens", "#32a14f"],
  ["Browns", "#94663e"],
  ["Cream", "#e3d8a3"],
  ["Khaki", "#e3d8a3"],
  ["Yellows", "#fcf947"],
  ["Oranges", "#e89b0c"],
  ["Reds", "#ed1f1f"],
  ["Pinks", "#ffc0cb"],
  ["Purples", "#a020f0"],
  ["Golds", "#ffd700"],
  ["Tan", "#D2B48C"],
  ["Beiges", "#F5F5DC"]
]);

const filterTooltips = {
  product_product_type: "Refine results by Department.",
  product_Colors_tags: "Choose from a variety of colors to match your decor.",
  product_new_main_colors: "Choose from a variety of colors to match your decor.",
  product_review_rating: "Discover our customers' favorite products.<br>(Suggestion: Try our Customer Review sorting)",
  sizes: "How big do you need? Select minimum and/or maximum sizes here.",
  product_Sizes_tags: "How big do you need? Select minimum and/or maximum sizes here.",
  product_size_new: "How big do you need? Select minimum and/or maximum sizes here.",
  product_Shapes_tags: "Refine results to a specific shape.",
  product_shape_new: "Refine results to a specific shape.",
  product_Styles_tags: "Choose your Style.",
  sellingPrice: "Refine results by Minimum and Maximum Price.<br>(Suggestion: Choose Width and Length first.)",
  product_Use_tags: "Refine results by how the product will be used.",
  product_thickness_new: "Refine results by rug thickness.",
  product_Weave_SearchFilter: "Set your preferred construction.",
  product_Weaves_tags: "Set your preferred construction.",
  product_Promotions_tags: "Take advantage of current promotions and discounts.",
  product_Materials_tags: "Refine your selection by material content.",
  brands: "Have a favorite Brand Name? Set that refinement here."
}

const productTypeCollectionHandleMap = {
    "Rugs": "rugs",
    "Rug Pads": "rug-pads",
    "Pillows": "pillows-and-poufs",
    "Home Accents": "incredible-decor",
    "Bedding": "incredible-bedding",
    "Lighting": "incredible-lighting",
    "Wall Decor": "wall-decor",
    "Furniture": "furniture",
};

const fixedUsedFilterValue = "Top Brands";

var totalResultsCount = 0;
var hasToRequestForNextPage = false;
var priceRange = null;
// Size Filter - Length-Width Change - 17/08/26
var filteredSizes = null;
var filteredNormalizedSizes = null;
var filteredShapes = null;
// (#1 - solution) Late variant-facet apply: parallel main + additional Filter APIs (2 calls).
// Generation tokens ensure stale additional responses never overwrite newer UI.
var variantFacetsFetchGeneration = 0;
var variantFacetsDataGeneration = 0;
var variantFacetsDomAppliedGeneration = 0;
var variantFacetsFetchController = null;
// Set on Start Over / Clear All (capture) so BEFORE_FILTERS strips width/length
// float ranges that Wizzy clearAll does not remove from memory.
var pendingClearProductSizeFloatFilters = false;

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      // console.log("wizzy init", data);
      // Support configurable collection banner - Merged - 06-07-2026
      if (!data.common.isOnCategoryPage) {
        data.common.lazyDOMConfig.contentDOMIdentifiers.push("main#main");
      }
      data.search.configs.pagination.appendInExistingList = true;
      window.wizzyConfig['search']['configs']['pagination']['infiniteScrollOffset'] = {
          desktop: 4000,
          mobile: 2000
      };
      data.filters.configs.keepOpenedInMobileAfterApply = true;

      data.search.view.templates.facets.rangeListItem = "#wizzy-facet-range-list-item";


      data.search.configs.facets.configs = data.search.configs.facets.configs.map(facet => {
        if (facet.key === "product_Thickness_tags") {
          return {
            ...facet,
            key: "product_thickness_new:float" // replace key only
          };
        }

        if (facet.key === "product_badge_judgeme") {
          return {
            ...facet,
            key: "product_review_rating"
          };
        }

        if (facet.key === "product_Sizes_tags") {
          return {
            ...facet,
            key: "product_size_new"
          };
        }

        if (facet.key === "product_Shapes_tags") {
          return {
            ...facet,
            key: "product_shape_new"
          };
        }
        
        return facet;
      });

      data.gridFilters.filters = data.gridFilters.filters.map(facet => {
        if (facet.key === "product_Sizes_tags") {
          return {
            ...facet,
            key: "product_size_new"
          };
        }
        
        return facet;
      });

      data.search.configs.facets.showPriceInputRangeFields = true;

      // Size Filter - Length-Width Change - 17/08/26
      // 2. Remove existing Length/Width if already present (avoid duplicates)
      data.search.configs.facets.configs = data.search.configs.facets.configs.filter(facet => 
        facet.key !== "sizes"
      );

      // 3. Append Length and Width always at the end with dynamic order
      const lastOrder = Math.max(...data.search.configs.facets.configs.map(f => f.order || 0), 0);

      data.search.configs.facets.configs.push(
        {
          "label": "All Sizes",
          "key": "sizes",
          "position": "left",
          "order": lastOrder + 1
        },
        {
          "label": "Length",
          "key": "product_length_new:float",
          "position": "left",
          "order": lastOrder + 2
        },
        {
          "label": "Width",
          "key": "product_width_new:float",
          "position": "left",
          "order": lastOrder + 3
        }
      );

      
      return data;
    }
  );
  
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED, function (payload) {
    document.addEventListener("click", function (e) {
      if (e.target.closest("#init-wizzy-featured-view-button")) {
        if (typeof window.initFeaturedView !== "undefined") {
          window.initFeaturedView({
            dom:'wizzyFeaturedViewRoot',
            filters:
              JSON.stringify(
                  window.wizzyConfig.pageStore.searchedResponse.filters),
            attributeIds: ["product_product_type",,"product_Sizes_SearchFilter"],
            displayImageInSquare: '9:16 Vertical Rectangle' === '1:1 Square',
            displayStoreName: true,
            displayDispalyAddToCartNumber: true,
            storeName: "Incredible rugs and decor",
            currentCartCount: 0,
            displayAddToCart: true,
            displayViewMore: true,
            attributesToShowOnViewMore: ["product_sku"]
          });
        }
      }
    });
    return payload;
  });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      // console.log("wizzy init", data);
      // Support configurable collection banner - Merged - 06-07-2026
    if (!data.common.isOnCategoryPage) {
        data.common.lazyDOMConfig.contentDOMIdentifiers.push("main#main");
    }
      const allowedCollections = [
      "karastan-spice-market-rug-collection",
      "karastan-adalia-rug-collection",
      "karastan-memento-rug-collection",
      "oriental-weavers-andorra-rug-collection",
      "oriental-weavers-aberdeen-rug-collection",
      "oriental-weavers-anastasia-rug-collection",
      "feizy-cadiz-rug-collection",
      "oriental-weavers-lucca-rug-collection"
    ];

    const currentHandle = window?.wizzyConfig?.common?.collectionHandle?.toLowerCase();

    if (allowedCollections.includes(currentHandle)) {
      document.body.classList.add('add-feature-view');
    }
      data.search.configs.pagination.appendInExistingList = true;
      window.wizzyConfig['search']['configs']['pagination']['infiniteScrollOffset'] = {
          desktop: 4000,
          mobile: 2000
      };
      data.filters.configs.keepOpenedInMobileAfterApply = true;

      data.search.view.templates.facets.rangeListItem = "#wizzy-facet-range-list-item";

      data.search.configs.facets.showPriceInputRangeFields = true;

      // Size Filter - Length-Width Change - 17/08/26
      // 2. Remove existing Length/Width if already present (avoid duplicates)
      data.search.configs.facets.configs = data.search.configs.facets.configs.filter(facet => 
        facet.key !== "sizes"
      );

      // 3. Append Length and Width always at the end with dynamic order
      const lastOrder = Math.max(...data.search.configs.facets.configs.map(f => f.order || 0), 0);

      data.search.configs.facets.configs.push(
        {
          "label": "All Sizes",
          "key": "sizes",
          "position": "left",
          "order": lastOrder + 1
        },
        {
          "label": "Length",
          "key": "product_length_new:float",
          "position": "left",
          "order": lastOrder + 2
        },
        {
          "label": "Width",
          "key": "product_width_new:float",
          "position": "left",
          "order": lastOrder + 3
        }
      );
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      // console.log("Wizzy AFTER_PRODUCTS_TRANSFORMED", data);
      data.forEach((product) => {
        if (product.groupId === "") {
          product.isParentProduct = true;
        }
        if (product.images?.length > 0) {
          product.mainImage = product.images[0];
        }
        if (typeof product.attributes === "undefined") {
          product.attributes = [];
        }

        let collectionHandle = "";
        let newMainColors = [];
        let stylesTags = [];
        let useTags = [];
        let colorPercentages = [];
        product.attributes.forEach((attribute) => {
          if (attribute.id === "product_badge_judgeme") {
            const rawHTML = attribute.values[0].value[0];

            // Parse the HTML string
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = rawHTML;
            const badge = tempDiv.querySelector(".jdgm-prev-badge");

            if (badge) {
              var reviews = parseInt(badge.getAttribute("data-number-of-reviews")) || 0;
              
              if (reviews > 0) {
                product.judgemeReviews = parseInt(badge.getAttribute("data-number-of-reviews")) || 0;
                product.judgemeRating = parseFloat(badge.getAttribute("data-average-rating")) || 0;

                // // Optional: star breakdown (for Mustache loops)
                product.judgemeSolidStars = Math.floor(product.judgemeRating);
                product.judgemeHalfStar = (product.judgemeRating % 1 >= 0.5) ? 1 : 0;
                product.judgemeEmptyStars = 5 - product.judgemeSolidStars - product.judgemeHalfStar;

                product.judgemeSolidStars = makeArray(product.judgemeSolidStars || 0);
                product.judgemeHalfStar = product.judgemeHalfStar ? [{}] : [];
                product.judgemeEmptyStars = makeArray(product.judgemeEmptyStars || 0);
              }
            }
          }
          if (attribute.id === "product_size_new") {
            product.selectedSize = attribute.values[0].value[0];
          }
          if (attribute.id === "product_handle") {
            product.handle = attribute.values[0].value[0];
          }

          if (attribute.id === "product_product_type") {
            const type = attribute.values[0]?.value[0] || "";
            collectionHandle = productTypeCollectionHandleMap[type] || "";
          }

          if (attribute.id === "product_new_primary_colors") {
            attribute.values.forEach(item => {
              if (item.value[0]) {
                const [hex, name] = item.value[0].split(",");
                newMainColors.push({ hex, name });
              }
            });
          }

          if (attribute.id === "product_Styles_tags") {
            attribute.values.forEach(item => {
              if (item.value[0]) stylesTags.push(item.value[0]);
            });
          }

          if (attribute.id === "product_Use_tags" && fixedUsedFilterValue && useTags.length === 0) {
            useTags.push(fixedUsedFilterValue);
          }

          if (attribute.id.startsWith("color_")) {
            // Extract color name from id (e.g., color_ivory -> Ivory)
            const colorName = attribute.id.replace("color_", "").replace(/_/g, " ");
            attribute.values.forEach(item => {
              if (item.value[0] !== undefined) {
                colorPercentages[colorName.toLowerCase()] = item.value[0];
              }
            });
          }
        });
        if (collectionHandle !== "" && newMainColors.length > 0) {
          let url = `https://incrediblerugsanddecor.com/collections/${collectionHandle}?`;

          newMainColors.forEach(color => {
            url += `product_new_primary_colors[]=${encodeURIComponent(color.hex + "," + color.name)}&`;

            const normalizedName = color.name.toLowerCase().replace(/_/g, " ");
            const perc = colorPercentages[normalizedName];
            if (perc !== undefined) {
              const adjustedPerc = Math.max(parseFloat(perc) - 5, 0).toFixed(2);
              if (adjustedPerc > 5) {
                const key = `color_${normalizedName.replace(/\s+/g, "_")}`;
                url += `${key}[]=${encodeURIComponent(adjustedPerc)}&`;
              }
            }
          });
          stylesTags.forEach(style => {
            url += `product_Styles_tags[]=${encodeURIComponent(style)}&`;
          });
          // useTags.forEach(use => {
          //   url += `product_Use_tags[]=${encodeURIComponent(use)}&`;
          // });

          product.moreLikeThisURL = url.replace(/&$/, "");
        }
      });

      return data;
    },
    1
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log("wizzy VIEW_RENDERED ---", data);
      var startOverbtn = document.querySelector('.wizzy-search-wrapper .wizzy_btn.btn.btn--primary.wizzy_filter-clear_button');

      if (startOverbtn) {
        startOverbtn.addEventListener('click', function(){
          var clearAllbtn = document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-header .wizzy-filters-clear-all');
          if (clearAllbtn) {
            clearAllbtn.click();
            data.data.response.payload.filters.page = 1;
          }
        });
      }

      formatSelectedPriceRangeLabels();

      formatSelectedSizeRangeLabels();

      replaceReviewFacetLabels();

      replaceSelectedReviewFacetLabels();

      handleInStockBtnOnClick();

      handleInStockBtnAfterClick();

      showFilterTooltip();

      hideBeforeSearchIconIfEmpty();

      handleScrollToTopButton();

      // Support configurable collection banner - Merged - 06-07-2026
      var wizzyWrapper = document.querySelector(".wizzy-search-wrapper");

      if (wizzyWrapper) {
        var activeSectionInner = wizzyWrapper.closest(".section-inner");

        if (activeSectionInner) {
          activeSectionInner.style.padding = "0";
        }

        var activeSection = wizzyWrapper.closest(".shopify-section");

        if (activeSection) {
          activeSection.style.overflow = "unset";
        }
      }
      
      document.querySelectorAll('.wizzy-selected-facet-list-item')?.forEach(item => {
        const existingSpan = item.querySelector('.facet-item-label-value-id');
        if (!existingSpan) {
          const facetKey = item.getAttribute('data-facetkey');
          const labelText = facetLabelsMap[facetKey];
          
          if (labelText) {
            const facetLabel = item.querySelector('.facet-item-label-value');
            if (facetLabel) {
              const newSpan = document.createElement('span');
              newSpan.className = 'facet-item-label-value-id';
              newSpan.textContent = ` ${labelText} `;
              facetLabel.insertBefore(newSpan, facetLabel.firstChild);
            }
          }
        }
      });

      var thicknessSlider = document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left .wizzy-facet-body.facet-body-product_thickness_new .wizzy-facet-range-slider');
      if (thicknessSlider) {
        updateNoUiSliderForSize(thicknessSlider, 'product_thickness_new');
        var pipValues = thicknessSlider.querySelectorAll('.noUi-value');

        pipValues.forEach(pip => {
          const rawValue = pip.getAttribute('data-value');
          if (rawValue !== null) {
            pip.textContent = formatInchesToFeetInches('product_thickness_new', rawValue);
          }
        });
      }

      if (window.wizzyConfig.common.isOnCategoryPage) {
        if (window.collectionName) {
          var cName = window.collectionName;
          var breadcrumbCollectionTitle = document.querySelector('.wizzy-search-wrapper .wizzy-collection-banner-new .collection-banner__breadcrumbs .breadcrumbs__current');
          if (breadcrumbCollectionTitle) {
            breadcrumbCollectionTitle.innerText = cName;
          }
          var headCollectionTitle = document.querySelector('.wizzy-search-wrapper .wizzy-collection-banner-new h1.collection-banner__text-container-heading.ff-heading');
          if (headCollectionTitle) {
            headCollectionTitle.innerText = cName;
          }
        }
      }
      
      var page = data?.data?.response?.payload?.filters?.page;
      var totalPages = data?.data?.response?.payload?.pages;
      var apiType = data?.data?.api;
      var filterType = data?.data?.response?.payload?.filters?.type;

      if (page !== undefined && totalPages !== undefined && (apiType === "filter" || apiType === "search") && !(filterType === "NO_RESULTS_FOUND") && page >= totalPages) {
        var endOfResultsDiv = document.querySelector('.wizzy-end-of-results');

        if (endOfResultsDiv) {
          endOfResultsDiv.innerText = '';
          endOfResultsDiv.innerText = 'End of results';
        }
      }

      // if (apiType && apiType === "filter") {
      //   if (hasToRequestForNextPage) {
      //     window.applyNextPage();
      //   }
      // }

      setTimeout(function(){
        if (window.location.href.includes('/collections/vendors')) {
          const url = new URL(window.location.href);
          const params = url.searchParams;

          // Take the first vendor value
          const vendor = params.get('product_vendor[]');

          if (vendor) {
            params.set('q', vendor);  // Add or replace the q param
            url.search = params.toString();

            // convert %5B%5D → [] for readability
            let cleanUrl = url.toString().replace(/%5B%5D/g, "[]");

            // update URL without reload
            window.history.replaceState({}, "", cleanUrl);
          }
        }
      }, 100);


      attachSliderTooltipGuard('.wizzy-facet-body.facet-body-sellingPrice .wizzy-facet-range-slider');
      attachSliderTooltipGuard('.wizzy-facet-body.facet-body-product_thickness_new .wizzy-facet-range-slider');

      pluralizeSelectedColorFacets();

      // Size Filter - Length-Width Change - 17/08/26
      createProductSizeDropdowns();
      preselectProductSizeDropdownsFromURL();

      updateProductSizeSelectedFilterLabels();
      initializeProductSizeSelectedFilterRemoval();
      initializeProductSizeClearAll();
      // updateProductSizeSelectedFilters();

      // (#1 - solution) If additional Filter already finished, rebuild facet lists/dropdowns now.
      applyLateVariantFacetsIfReady();

      window.export?.ProductItem?.(document.querySelector('.wizzy-search-results-list'));
      window.export?.ProductItem?.(document.querySelector('.autocomplete-top-products'));
      
      return data;
    }, 1
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log("wizzy VIEW_RENDERED again", data);
      

      setTimeout(function(){
        // console.log("Wizzy", window._roomvo["incrediblerugsanddecor"]._isPlpPage());
        if (window._roomvo && window._roomvo["incrediblerugsanddecor"]) {
          window._roomvo["incrediblerugsanddecor"]._isPlpPage = () => true;
        }
        window._roomvo?.["incrediblerugsanddecor"]?.onBodyLoaded?.();
        // console.log("Wizzy again", window._roomvo["incrediblerugsanddecor"]._isPlpPage());
      }, 3000);

      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      // console.log("wizzy BEFORE_SEARCH_EXECUTED", data);
      const button = document.querySelector('.init-wizzy-featured-view-button');

      if (button) {
          button.style.display = 'none';
      }
      data.attributeFacetValuesLimit = 50;

      data.facets.forEach(facet => {
        if (facet.key === "product_Thickness_tags") {
          facet.key = "product_thickness_new:float";
        }

        if (facet.key === "product_badge_judgeme") {
          facet.key = "product_review_rating";
        }

        if (facet.key === "product_Sizes_tags") {
          facet.key = "product_size_new";
        }

        if (facet.key === "product_Shapes_tags") {
          facet.key = "product_shape_new";
        }
      });

      if (data.sort && data.sort.length >= 1) {
        if (data.sort[0].field === "relevance") {
          data.sort = [
            {
              field: "relevance",
              order: "asc",
            },
            {
              field: "product_wizzy-best-selling_sortOrder:float",
              order: "asc",
            },
            {
              field: "sellingPrice",
              order: "asc",
              isForParent: false,
              isForVariation: true
            }
          ];
          // var alreadyAdded = data.sort.some(
          //   (s) => s.field === "sellingPrice"
          // );

          // if (!alreadyAdded) {
          //   data.sort.push(
          //   {
          //     field: "product_wizzy-best-selling_sortOrder:float",
          //     order: "asc",
          //   },
          //   {
          //     field: "sellingPrice",
          //     order: "asc",
          //     isForParent: false,
          //     isForVariation: true
          //   });
          // }
        }
      }

      window.wizzyConfig.gridFilters.filters = window.wizzyConfig.gridFilters.filters.map(facet => {
        if (facet.key === "product_Sizes_tags") {
          return {
            ...facet,
            key: "product_size_new"
          };
        }
        
        return facet;
      });

      // Changes done by Wizzy to make sure the queries containing special character returns accurate results - 19-06-2026
      if(data.q) {
        data.q = data.q.replace(/[^a-zA-Z0-9 ]/g, ' ').trim();
      }

      // Support configurable collection banner - Merged - 06-07-2026
      var wizzyWrapper = document.querySelector(".wizzy-search-wrapper");

      if (wizzyWrapper) {
        var activeSection = wizzyWrapper.closest(".shopify-section");

        document.querySelectorAll("main#main .shopify-section").forEach(section => {
          if (section !== activeSection) {
            section.style.display = "none";
          }
        });
      }

      // Size Filter - Length-Width Change - 17/08/26
      data.facets = data.facets.filter(facet => 
        facet.key !== "sizes"
      );

      const lastOrder = Math.max(
        ...data.facets.map(f => f.order || 0),
        0
      );

      data.facets.push(
        {
          label: "All Sizes",
          key: "sizes",
          position: "left",
          order: lastOrder + 1
        },
        {
          "label": "Length",
          "key": "product_length_new:float",
          "position": "left",
          "order": lastOrder + 2
        },
        {
          "label": "Width",
          "key": "product_width_new:float",
          "position": "left",
          "order": lastOrder + 3
        }
      );
      
      return data;
    }, 3
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      // console.log("wizzy BEFORE_AUTOCOMPLETE_EXECUTED", data);

      if (data.sort && data.sort.length >= 1) {
        if (data.sort[0].field === "relevance") {
          var alreadyAdded = data.sort.some(
            (s) => s.field === "sellingPrice"
          );

          // if (!alreadyAdded) {
          //   data.sort.push(
          //   {
          //     field: "product_wizzy-best-selling_sortOrder:float",
          //     order: "asc",
          //   },
          //   {
          //     field: "sellingPrice",
          //     order: "asc",
          //     isForParent: false,
          //     isForVariation: true
          //   });
          // }
        }

        data.sort = [
          {
            field: "product_wizzy-best-selling_sortOrder:float",
            order: "asc",
          },
          {
            field: "relevance",
            order: "asc"
          },
          {
            field: "sellingPrice",
            order: "asc",
            isForParent: false,
            isForVariation: true
          }
        ]
      }
      
      // Changes done by Wizzy to make sure the queries containing special character returns accurate results - 19-06-2026
      if(data.q) {
        data.q = data.q.replace(/[^a-zA-Z0-9 ]/g, ' ').trim();
      }
      
      return data;
    }, 1
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // console.log("wizzy init", data);
      var startOverbtn = document.querySelector('.wizzy-search-wrapper .wizzy_btn.btn.btn--primary.wizzy_filter-clear_button');

      if (startOverbtn) {
        startOverbtn.addEventListener('click', function(){
          var clearAllbtn = document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-header .wizzy-filters-clear-all');
          if (clearAllbtn) {
            clearAllbtn.click();
            data.data.response.payload.filters.page = 1;
          }
        });
      }

      formatSelectedPriceRangeLabels();

      formatSelectedSizeRangeLabels();

      replaceReviewFacetLabels();

      replaceSelectedReviewFacetLabels();

      handleInStockBtnOnClick();

      showFilterTooltip();

      hideBeforeSearchIconIfEmpty();

      handleScrollToTopButton();
      
      document.querySelectorAll('.wizzy-selected-facet-list-item')?.forEach(item => {
        const existingSpan = item.querySelector('.facet-item-label-value-id');
        if (!existingSpan) {
          const facetKey = item.getAttribute('data-facetkey');
          const labelText = facetLabelsMap[facetKey];
          
          if (labelText) {
            const facetLabel = item.querySelector('.facet-item-label-value');
            if (facetLabel) {
              const newSpan = document.createElement('span');
              newSpan.className = 'facet-item-label-value-id';
              newSpan.textContent = ` ${labelText} `;
              facetLabel.insertBefore(newSpan, facetLabel.firstChild);
            }
          }
        }
      });

      var thicknessSlider = document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left .wizzy-facet-body.facet-body-product_thickness_new .wizzy-facet-range-slider');
      if (thicknessSlider) {
        updateNoUiSliderForSize(thicknessSlider, 'product_thickness_new');
        var pipValues = thicknessSlider.querySelectorAll('.noUi-value');

        pipValues.forEach(pip => {
          const rawValue = pip.getAttribute('data-value');
          if (rawValue !== null) {
            pip.textContent = formatInchesToFeetInches('product_thickness_new', rawValue);
          }
        });
      }

      if (window.wizzyConfig.common.isOnCategoryPage) {
        if (window.collectionName) {
          var cName = window.collectionName;
          var breadcrumbCollectionTitle = document.querySelector('.wizzy-search-wrapper .wizzy-collection-banner-new .collection-banner__breadcrumbs .breadcrumbs__current');
          if (breadcrumbCollectionTitle) {
            breadcrumbCollectionTitle.innerText = cName;
          }
          var headCollectionTitle = document.querySelector('.wizzy-search-wrapper .wizzy-collection-banner-new h1.collection-banner__text-container-heading.ff-heading');
          if (headCollectionTitle) {
            headCollectionTitle.innerText = cName;
          }
        }
      }

      document.body.classList.add("wizzy-search-results-rendered");

      attachSliderTooltipGuard('.wizzy-facet-body.facet-body-sellingPrice .wizzy-facet-range-slider');
      attachSliderTooltipGuard('.wizzy-facet-body.facet-body-product_thickness_new .wizzy-facet-range-slider');

      pluralizeSelectedColorFacets();

      // Size Filter - Length-Width Change - 17/08/26
      createProductSizeDropdowns();
      preselectProductSizeDropdownsFromURL();

      updateProductSizeSelectedFilterLabels();
      initializeProductSizeSelectedFilterRemoval();
      initializeProductSizeClearAll();
      // updateProductSizeSelectedFilters();

      // (#1 - solution) If additional Filter already finished, rebuild facet lists/dropdowns now.
      applyLateVariantFacetsIfReady();

      window.export?.ProductItem?.(document.querySelector('.wizzy-search-results-list'));

      setTimeout(function(){
        // console.log("Wizzy", window._roomvo["incrediblerugsanddecor"]._isPlpPage());
        if (window._roomvo && window._roomvo["incrediblerugsanddecor"]) {
          window._roomvo["incrediblerugsanddecor"]._isPlpPage = () => true;
        }
        window._roomvo?.["incrediblerugsanddecor"]?.onBodyLoaded?.();
        // console.log("Wizzy again", window._roomvo["incrediblerugsanddecor"]._isPlpPage());
      }, 3000);

      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      // console.log(data,"WIZZY BEFORE_RENDER_RESULTS");

      
      if(data.response.payload){
        if(data.response.payload.facets){
          const FacetList = data.response.payload.facets;
          var appliedShapes = data.response?.payload?.filters?.attributes?.product_shape_new ?? [];
          var appliedSizes = data.response?.payload?.filters?.attributes?.product_size_new ?? [];
          // console.log(FacetList,"Facet List");
          if(FacetList){
            FacetList.forEach(facet => {
              if(facet.key === "product_new_primary_colors"){
                const colorsList = facet.data;
                if(colorsList){
                  colorsList.forEach(color => {
                    const colorKey = color.key;
                    const [backgroundHex] = color.key.split(",");
                    const colorName = color.key.split(",")[1];
                    color.isSwatch = true;
                    color.isVisualSwatch = true;
                    color.swatchValue = backgroundHex;
                    color.label = colorName;
                    color.data = {
                          value: color.key,
                          swatch: {
                              type: 'visual',
                              value: backgroundHex
                          }
                      }
                  })
                }
              }

              if (facet.key === "product_size_new") {
                let sizes = facet.data;
      
                let newArray = new Array();
                let temp = [
                  "2' x 3'",
                  "3' x 5'",
                  "4' x 6'",
                  "5' x 8'",
                  "6' Runner",
                  "6' Round",
                  "6' Square",
                  "6' x 9'",
                  "8' Runner",
                  "8' Round",
                  "8' Square",
                  "8' x 10'",
                  "8' x 11'",
                  "9' x 12'",
                  "10' Runner",
                  "10'+ Round",
                  "10'+ Square",
                  "10' x 14'",
                  "12' x 15'+",
                  "12'+ Runner",
                  "Custom Size"
                ];
                for (let j = 0; j < temp.length; j++) {
                  for (let k = 0; k < sizes.length; k++) {
                    if (sizes[k].key == temp[j]) newArray.push(sizes[k]);
                  }
                }
      
                facet.data = newArray;
              }

              if (facet.key === "product_shape_new") {
                let shapes = facet.data;
                const allowedShapeFacets = ["rectangle", "round", "square", "runner"];

                shapes = shapes.filter(item => {
                  const key = item.key.trim().toLowerCase();

                  return allowedShapeFacets.includes(key);
                });

                facet.data = shapes;
              }

              if (facet.key === "product_review_rating") {
                let facetItem = facet.data;
              
                facetItem = facetItem
                  .filter(item => {
                    const val = Number(item.key);
                    if (isNaN(val)) return false;
                    if (val <= 2) return false;
                    return true;
                  })
                  .sort((a, b) => b.key - a.key);

                facet.data = facetItem;
              }

              if (facet.key === "product_size_new" && appliedShapes?.length) {
                const validShapes = appliedShapes.filter(shape => SHAPE_TO_SIZES[shape]);

                if (validShapes.length) {
                  const allowed = new Set();

                  validShapes.forEach(shape => {
                      SHAPE_TO_SIZES[shape].forEach(size => allowed.add(size));
                  });

                  facet.data = facet.data.filter(s => 
                    allowed.has(s.key) || appliedSizes.includes(s.key)
                  );
                }
              }

              if (facet.key === "product_shape_new" && appliedSizes?.length) {
                const validSizes = appliedSizes.filter(size => SIZE_TO_SHAPE[size]);

                if (validSizes.length) {
                  const allowedShapes = new Set();

                  validSizes.forEach(size => {
                      const shape = SIZE_TO_SHAPE[size];
                      allowedShapes.add(shape);
                  });

                  facet.data = facet.data.filter(s => 
                    allowedShapes.has(s.key) || allowedShapes.has(s.key)
                  );
                }
              }

              if (facet.key === "inStock" && facet.data.length === 1 && facet.data[0]?.key === "true") {
                facet.data.push({
                  count: 1,
                  label: 'dummy',
                  key: 'dummy'
                });
              }
            })
          }
        }
      }
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      // console.log("wizzy BEFORE_FILTERS_EXECUTED", data.filters);

      if (data.filters) {

        // if (window.wizzyShowOnlyInstock === true) {
        //   data.filters.inStock = ["true"];
        // } else {
        //   data.filters.inStock = [];
        // }

        if (data.filters.categories && data.filters.categories.length > 0 && data.filters.categories[0] === "vendors") {
          data.filters.categories = [];
          vendorValue = window.collectionName ?? "Karastan";
          data.filters.attributes = {
            ...(data.filters.attributes || {}),
            product_vendor: [vendorValue]
          };
        }

        if (data.filters.sort[0].field === "sellingPrice") {
          data.filters.showOOSProductsInOrder = "true";
          var sortOrder = data.filters.sort[0].order;
          data.filters.sort = [{
            field: "sellingPrice",
            order: sortOrder,
          },
          {
            field: "product_wizzy-best-selling_sortOrder:float",
            order: "asc",
          }];
        } else {
          data.filters.showOOSProductsInOrder = "false";
        }

        if (data.filters.sort[0].field === "discountPercentage") {
          data.filters.showOOSProductsInOrder = "true";
          var sortOrder = data.filters.sort[0].order;
          data.filters.sort = [{
            field: "discountPercentage",
            order: sortOrder,
          },
          {
            field: "product_wizzy-best-selling_sortOrder:float",
            order: "asc",
          }];
        } else {
          data.filters.showOOSProductsInOrder = "false";
        }

        data.filters.attributeFacetValuesLimit = 50;

        const floatKeys = ["product_thickness_new"];

        // ensure floatAttributes exists
        // Size Filter - Length-Width Change - 17/08/26
        data.filters.floatAttributes = data.filters.floatAttributes || {};

        floatKeys.forEach((attrKey) => {
          if (data.filters[attrKey]) {
            data.filters.floatAttributes[attrKey] = data.filters[attrKey];
          }
        });

        if (data.filters.attributes) {
          var attrs = data.filters.attributes;

          floatKeys.forEach(key => {
            if (attrs.hasOwnProperty(key)) {
              delete attrs[key];
              const urlParams = new URLSearchParams(window.location.search);

              const gteKey = `fA.${key}.gte[]`;
              const lteKey = `fA.${key}.lte[]`;

              const gte = urlParams.get(gteKey);
              const lte = urlParams.get(lteKey);

              if (gte || lte) {
                const entry = {};
                if (gte) entry.gte = gte;
                if (lte) entry.lte = lte;

                data.filters.floatAttributes[key] = [entry];
                data.filters[key] = [entry];
              }
            }
          });
        }

        // Size Filter - Length-Width Change - 17/08/26
        var additionalFloatKeys = ["product_width_new","product_length_new"]; 

        if (data.filters.attributes) {
          var attrs = data.filters.attributes;

          // additionalFloatKeys.forEach(key => {
          //   if (attrs.hasOwnProperty(key)) {
          //     delete attrs[key];
          //     data.filters[key] = data.filters.floatAttributes[key];
          //   } else if (data.filters.floatAttributes.hasOwnProperty(key)) {
          //     delete data.filters.floatAttributes[key];
          //   }
          // });

          data.filters.floatAttributes = data.filters.floatAttributes || {};

          // Start Over / Clear All: Wizzy clearAll does not remove floatAttributes /
          // top-level product_width_new|product_length_new. Without this, the keep-
          // floatAttributes fix above would re-apply them and leave
          // product_width_new[]=[object Object] in the URL.
          if (pendingClearProductSizeFloatFilters) {
            additionalFloatKeys.forEach(key => {
              if (attrs.hasOwnProperty(key)) {
                delete attrs[key];
              }
              delete data.filters.floatAttributes[key];
              delete data.filters[key];
            });
            pendingClearProductSizeFloatFilters = false;
          } else {
            additionalFloatKeys.forEach(key => {
              // Empty chip (product_width_new[]=) is only for selected-facet UI.
              if (attrs.hasOwnProperty(key)) {
                delete attrs[key];
              }

              var rangeValues = null;
              if (data.filters.floatAttributes[key]) {
                rangeValues = data.filters.floatAttributes[key];
              } else if (
                Array.isArray(data.filters[key]) &&
                data.filters[key][0] &&
                typeof data.filters[key][0] === "object"
              ) {
                // Recover range if a prior run left it only on top-level.
                rangeValues = data.filters[key];
              }

              if (rangeValues) {
                data.filters.floatAttributes[key] = rangeValues;
                // Top-level required for selected filters display + remove handling.
                data.filters[key] = rangeValues;
              }
            });
          }
        }

        if (data.filters.sort && data.filters.sort.length >= 1) {
          if (data.filters.sort[0].field === "relevance") {
            data.filters.sort = [
              {
                field: "relevance",
                order: "asc",
                isForParent: true,
                isForVariation: false
              },
              {
                field: "product_wizzy-best-selling_sortOrder:float",
                order: "asc",
                isForParent: true,
                isForVariation: false
              },
              {
                field: "sellingPrice",
                order: "asc",
                isForParent: false,
                isForVariation: true
              }
            ];
          }

          if (data.filters.sort[0].field === "avgRatings") {
            data.filters.sort = [
              {
                field: "average_review_score",
                order: "desc"
              },
              {
                field: "product_wizzy-best-selling_sortOrder:float",
                order: "asc"
              }
            ];
          }
        }

        // data.filters.variantsGroupBy = "groupId";
        // data.filters.getAllVariants = "true";
        data.filters.boostGroupIds = [];

        if (data.filters.categories && data.filters.categories.length > 0 && data.filters.sort && data.filters.sort.length >= 1 && (data.filters.sort[0].field === "relevance" || data.filters.sort[0].field === "product_wizzy-best-selling_sortOrder:float")) {
          data.filters.boostMatches = ["product_new_primary_colors", "product_Styles_tags"];
          if (data.filters.attributes && data.filters.attributes.product_new_primary_colors && data.filters.attributes.product_new_primary_colors.length > 0) {
            data.filters.boostGroupIds = [];
            if (Array.isArray(data.filters.facets)) {
              data.filters.facets = data.filters.facets.map(facet => {
                // if (facet.key === "product_Colors_tags") {
                //   return { ...facet, key: "product_new_main_colors" };
                // }
                return facet;
              });
              data.filters.facets.push({
                "key": "product_new_primary_colors",
                "label": "Colors",
                "position": "left",
                "order": 15
              })
            }
          } else {
            const facets = data.filters.facets;
            if (Array.isArray(facets)) {
              data.filters.facets = data.filters.facets.map(facet => {
                if (facet.key === "product_new_main_colors") {
                  return { ...facet, key: "product_Colors_tags" };
                }
                return facet;
              });
            } else if (facets && typeof facets === "object") {
              Object.keys(facets).forEach(key => {
                if (key === "product_new_main_colors") {
                  facets["product_Colors_tags"] = {
                    ...facets[key],
                    key: "product_Colors_tags",
                  };
                  delete facets[key];
                }
              });
            }
          }
        }
      }

      // Color Percentage Apply Logic
      if (data.filters && data.filters.attributes) {
        var attrs = data.filters.attributes;

        const mainColors = attrs.product_new_primary_colors || [];
        const currentColorHexNames = mainColors.map(c => {
          const parts = c.split(",");
          return parts[1].toLowerCase().trim().replace(/\s+/g, "_");; // extract color name
        });

        const colorKeys = [
          ...Object.keys(data.filters).filter(k => k.startsWith("color_")),
          ...Object.keys(attrs).filter(k => k.startsWith("color_"))
        ];

        if (!data.filters.attributes.product_new_primary_colors || data.filters.attributes.product_new_primary_colors.length === 0) {
          colorKeys.forEach(key => {
            delete data.filters[key];
            if (data.filters.floatAttributes && data.filters.floatAttributes[key]) {
              delete data.filters.floatAttributes[key];
            }
            if (data.filters.attributes && data.filters.attributes[key]) {
              delete data.filters.attributes[key];
            }
          });

          const colorFloatKeys = Object.keys(data.filters).filter(k => k.startsWith("color_"));
          colorFloatKeys.forEach(key => {
            delete data.filters[key];
          });
        } else {
          Object.keys(data.filters).forEach((key) => {
            if (key.startsWith("color_")) {
              const colorName = key.replace("color_", "");
              const values = data.filters[key];

              const isColorAllowed = currentColorHexNames.includes(colorName);

              if (Array.isArray(values) && values.length > 0) {
                if (isColorAllowed) {
                  data.filters.floatAttributes[key] = values;
                  data.filters[key] = values;
                } else {
                  delete data.filters.floatAttributes?.[key];
                  delete data.filters[key];
                }
                delete data.filters.attributes[key];
              }
            }
          });
        }

        // --- Handle dynamic color percentage float attributes ---
        Object.keys(attrs).forEach((key) => {
          if (key.startsWith("color_")) {
            const colorName = key.replace("color_", "");
            const values = attrs[key];
            const rawValue = Array.isArray(values) ? values[0] : null;

            const isColorAllowed = currentColorHexNames.includes(colorName);
            
            if (isColorAllowed && isValidNumber(rawValue)) {
              const entry = { gte: Number(rawValue).toFixed(2) };

              data.filters.floatAttributes[key] = [entry];
              data.filters[key] = [entry];
            } else {
              // invalid / null / NaN → clean everywhere
              delete data.filters.floatAttributes?.[key];
              delete data.filters[key];
            }
            delete data.filters.attributes[key];
          }
        });
      }


      // Fetching Updated Selling Price Logic Accoring to the filters applied
      // Size Filter - Length-Width Change - 17/08/26
      if (data?.filters) {
        var attrs1 = data.filters.attributes || {};
        var floatAttrs1 = data.filters.floatAttributes || {};

        var sizeFilters = attrs1.product_size_new || [];
        var shapeFilters = attrs1.product_shape_new || [];
        var widthFilters = floatAttrs1.product_width_new || data.filters.product_width_new || [];
        var lengthFilters = floatAttrs1.product_length_new || data.filters.product_length_new || [];
        var page = data.filters.page;

        const hasDimensionFilters = sizeFilters.length > 0 || shapeFilters.length > 0 || widthFilters.length > 0 || lengthFilters.length > 0;

        if (page === 1 && hasDimensionFilters) {
          // Size Filter - Length-Width Change - 17/08/26
          // (#1 - solution) Bump generation so in-flight older additional calls become stale.
          variantFacetsFetchGeneration += 1;
          fetchSellingPriceRangeAndSizes(data, variantFacetsFetchGeneration);
        } else if (!hasDimensionFilters) {
          priceRange = null;
          // Size Filter - Length-Width Change - 17/08/26
          filteredSizes = null;
          filteredNormalizedSizes = null;
          filteredShapes = null;
          // (#1 - solution) Reset late-apply generation state when dimension filters are cleared.
          variantFacetsFetchGeneration += 1;
          variantFacetsDataGeneration = 0;
          variantFacetsDomAppliedGeneration = 0;
        }
      }

      // ---------------------------------------------
      // SIZE / SHAPE + SELLING PRICE COMBINATION
      // (Non-destructive version)
      // ---------------------------------------------
      if (data.filters) {

        const attrs = data.filters.attributes || {};
        const sellingPrice = data.filters.sellingPrice || [];

        const sizeFilters = attrs.product_size_new || [];
        const shapeFilters = attrs.product_shape_new || [];

        const hasPrice = Array.isArray(sellingPrice) && sellingPrice.length > 0;
        const hasSizeOrShape = sizeFilters.length > 0 || shapeFilters.length > 0;

        if (hasPrice && hasSizeOrShape) {

          // ensure floatAttributes exists
          data.filters.floatAttributes = data.filters.floatAttributes || {};

          const floatAttrs = data.filters.floatAttributes;

          console.log("Wizzy float", floatAttrs);

          const normalizeAttributeKey = (value) => {
            if (!value) return "";
            return value
              .toString()
              .trim()
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "_")
              .replace(/^_+|_+$/g, "");
          };

          // ---- SIZE ----
          if (sizeFilters.length > 0) {

            const normalized = normalizeAttributeKey(sizeFilters[0]);
            if (normalized) {
              const floatKey = `product_size_${normalized}_price`;
              floatAttrs[floatKey] = sellingPrice;
            }
          }

          // ---- SHAPE ----
          if (shapeFilters.length > 0) {

            const normalized = normalizeAttributeKey(shapeFilters[0]);
            if (normalized) {
              const floatKey = `product_shape_${normalized}_price`;
              floatAttrs[floatKey] = sellingPrice;
            }
          }
        }
      }
      
      return data;
    }, 3
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      // console.log(data,"AFTER_WIZZY_API_RESPONDED");

      if (data && data.response && data.api == "filter") {
        var results = data.response.payload.result;
        var filters = data.response.payload.filters || {};
        var floatAttributes = data.response.payload.filters.floatAttributes || {};
        var attributes = filters.attributes || {};

        const colorKeys = [
          ...Object.keys(floatAttributes).filter(k => k.startsWith("color_"))
        ];
        var page = data.response.payload.filters.page;

        const allowedAttributeKeys = ["product_Styles_tags", "product_new_primary_colors"];
        const hasExtraAttributes = Object.keys(attributes).some(
          key => !allowedAttributeKeys.includes(key)
        );
        const hasBrands = filters.brands && filters.brands.length > 0;
        const hasSellingPrice = filters.sellingPrice && filters.sellingPrice.length > 0;
        const hasInStock = filters.inStock && filters.inStock.length > 0;

        var hasAnyOtherFilterApplied = hasExtraAttributes || hasBrands || hasSellingPrice || hasInStock;

        if (results.length < 7 && colorKeys.length > 1 && page && page === 1 && !hasAnyOtherFilterApplied) {
          console.log("🟡 WIZZY Few results + color filters detected... processing");

          try {
            const currentUrl = new URL(window.location.href);
            const params = currentUrl.searchParams;

            // Extract all color_ parameters and their numeric values
            const colorValues = [];
            for (const [key, value] of params.entries()) {
              if (key.startsWith("color_")) {
                colorValues.push({ key, value: parseFloat(value) });
              }
            }

            if (colorValues.length > 0) {
              // Sort by numeric value ascending
              colorValues.sort((a, b) => a.value - b.value);

              let colorsToUpdate = [];
              if (colorValues.length > 4) {
                // Update the lowest 3
                colorsToUpdate = colorValues.slice(0, 3);
              } else if (colorValues.length > 3) {
                // Update the lowest 2
                colorsToUpdate = colorValues.slice(0, 2);
              } else if (colorValues.length > 2) {
                // Update the lowest 1
                colorsToUpdate = colorValues.slice(0, 1);
              } else if (colorValues.length > 1) {
                // Update the lowest 1
                colorsToUpdate = colorValues.slice(0, 1);
              }

              if (colorsToUpdate.length > 0) {
                console.log("🎨 WIZZY Decreasing lowest color values by 5:", colorsToUpdate);

                // Remove those color_ params from URL
                colorsToUpdate.forEach(item => {
                  const newVal = Math.max(0, item.value - 5);

                  // Remove old param first
                  params.delete(item.key);

                  // If still positive, add back with reduced value
                  if (newVal > 0) {
                    params.append(item.key, newVal.toFixed(2));
                  } else {
                    console.log(`🗑️ WIZZY Removing ${item.key} since value dropped to 0`);
                  }
                });

                // Rebuild the new URL
                var newUrl = `${currentUrl.origin}${currentUrl.pathname}?${params.toString()}`;
                newUrl = newUrl.replace(/%5B%5D/g, "[]");
                console.log("🟢 WIZZY New URL after cleaning low color filters:", newUrl);

                // Execute Wizzy filters from URL
                if (typeof window.executeWizzyFiltersFromURL === "function") {
                  setTimeout(function(){
                    console.log("🚀 WIZZY Calling executeWizzyFiltersFromURL...");
                    window.executeWizzyFiltersFromURL(newUrl);
                  }, 500);
                } else {
                  console.warn("⚠️ WIZZY executeWizzyFiltersFromURL not found on window");
                }
              } else {
                console.log("✅ WIZZY No color filters removed — conditions not met.");
              }
            }
          } catch (err) {
            console.error("❌ WIZZY Error while processing color filters:", err);
          }
        }
      }

      // console.log(data," WIZZY AFTER_WIZZY_API_RESPONDED");

      if (data && data.response && data.api == "filter") {
        // const filters = data?.response?.payload?.filters;

        // const attrs = filters?.attributes;
        // const normalizedAttrs = Array.isArray(attrs) ? {} : (attrs || {});

        // const sizeValues = normalizedAttrs.product_size_new || [];
        // const shapeValues = normalizedAttrs.product_shape_new || [];
        // const sellingPriceValues = filters?.sellingPrice || [];

        // const hasMultipleSizes = sizeValues.length > 0;
        // const hasMultipleShapes = shapeValues.length > 0;
        // const hasSellingPrice = sellingPriceValues.length > 0;

        // const shouldRequestNextPage =
        //   (hasMultipleSizes && hasSellingPrice) ||
        //   (hasMultipleSizes && hasMultipleShapes && hasSellingPrice) ||
        //   (hasMultipleShapes && hasSellingPrice);

        // if (shouldRequestNextPage) {
        //   var results = data.response.payload.result;
        //   var page = data.response.payload.filters.page;
        //   var totalPages = data.response.payload.pages;
        //   results = results.filter(item => item.groupId !== "");
        //   data.response.payload.result = results;
        //   totalResultsCount += results.length;
        //   if (totalResultsCount < 24) {
        //     if (page < totalPages) {
        //       hasToRequestForNextPage = true;
        //     } else {
        //       hasToRequestForNextPage = false;
        //       totalResultsCount = 0;
        //     }
        //   }
        // }

      //   if (priceRange) {
      //     const facets = data?.response?.payload?.facets;
      //     if (facets && Array.isArray(facets)) {
      //       data.response.payload.facets = data.response.payload.facets.map(facet => {
      //         if (facet.key === "sellingPrice") {
      //           return { ...facet, data: priceRange };
      //         }
      //         return facet;
      //       });
      //     } else if (facets && typeof facets === "object") {
      //       Object.keys(facets).forEach(key => {
      //         if (key === "sellingPrice") {
      //           facets["sellingPrice"] = {
      //             ...facets[key],
      //             data: priceRange,
      //           };
      //           delete facets[key];
      //         }
      //       });
      //     }
      //   }
      // }
      // // Size Filter - Length-Width Change - 17/08/26
        // if (filteredSizes) {
        //   const facets = data?.response?.payload?.facets;
        //   if (facets && Array.isArray(facets)) {
        //     data.response.payload.facets = data.response.payload.facets.map(facet => {
        //       if (facet.key === "sizes") {
        //         return { ...facet, data: filteredSizes };
        //       }
        //       return facet;
        //     });
        //   } else if (facets && typeof facets === "object") {
        //     Object.keys(facets).forEach(key => {
        //       if (key === "sizes") {
        //         facets["sizes"] = {
        //           ...facets[key],
        //           data: filteredSizes,
        //         };
        //         delete facets[key];
        //       }
        //     });
        //   }
        // }

        // if (filteredNormalizedSizes) {
        //   const facets = data?.response?.payload?.facets;
        //   if (facets && Array.isArray(facets)) {
        //     data.response.payload.facets = data.response.payload.facets.map(facet => {
        //       if (facet.key === "product_size_new") {
        //         return { ...facet, data: filteredNormalizedSizes };
        //       }
        //       return facet;
        //     });
        //   } else if (facets && typeof facets === "object") {
        //     Object.keys(facets).forEach(key => {
        //       if (key === "product_size_new") {
        //         facets["product_size_new"] = {
        //           ...facets[key],
        //           data: filteredNormalizedSizes,
        //         };
        //         delete facets[key];
        //       }
        //     });
        //   }
        // }

        // if (filteredShapes) {
        //   const facets = data?.response?.payload?.facets;
        //   if (facets && Array.isArray(facets)) {
        //     data.response.payload.facets = data.response.payload.facets.map(facet => {
        //       if (facet.key === "product_shape_new") {
        //         return { ...facet, data: filteredShapes };
        //       }
        //       return facet;
        //     });
        //   } else if (facets && typeof facets === "object") {
        //     Object.keys(facets).forEach(key => {
        //       if (key === "product_shape_new") {
        //         facets["product_shape_new"] = {
        //           ...facets[key],
        //           data: filteredShapes,
        //         };
        //         delete facets[key];
        //       }
        //     });
        //   }
        // }

        if (hasFreshVariantFacetData()) {
          applyVariantFacetDataToPayload(data.response.payload);
        }
      }

      return data;
    }
  );

  // 31/08/26 - Add resolved collection URLs directly to category suggestion links. 
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
    function (data) {
      // console.log("wizzy BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER", data);

      var openCategoryPage =
      window.wizzyConfig &&
      window.wizzyConfig.autocomplete &&
      window.wizzyConfig.autocomplete.configs &&
      window.wizzyConfig.autocomplete.configs.general &&
      window.wizzyConfig.autocomplete.configs.general.openCategoryPage === true;

      var suggestionFilters =
        window.wizzyConfig &&
        window.wizzyConfig.pageStore &&
        window.wizzyConfig.pageStore.suggestionFilters
          ? window.wizzyConfig.pageStore.suggestionFilters
          : [];

      var suggestions = data.suggestions || [];
      var modifiedSuggestions = [];
      var i;
      var suggestion;
      var filterEntry;
      var collectionUrl;

      for (i = 0; i < suggestions.length; i++) {
        suggestion = suggestions[i];
        collectionUrl = "";
        if (
          openCategoryPage &&
          suggestion &&
          suggestion.isHead !== true &&
          suggestion.group === "categories" &&
          typeof suggestion.index !== "undefined" &&
          suggestionFilters[suggestion.index] &&
          suggestionFilters[suggestion.index].data &&
          suggestionFilters[suggestion.index].data.url
        ) {
          collectionUrl = suggestionFilters[suggestion.index].data.url;
        }
        modifiedSuggestions.push(
          Object.assign({}, suggestion, {
            collectionUrl: collectionUrl
          })
        );
      }
      data.suggestions = modifiedSuggestions;
      
      return data;
    }, 1
  );
}

function formatSelectedPriceRangeLabels() {
  const currencySymbol = window.wizzyConfig.store.currency.symbol;
  const facetItems = document.querySelectorAll(
    '.wizzy-selected-facet-list .wizzy-selected-facet-list-item[data-facetkey="sellingPrice"] .facet-item-label-value'
  );

  facetItems.forEach(item => {
    let rawText = item.textContent.trim();

    // remove "Price :" label if present
    let value = rawText.replace(/^Price\s*:/i, '').trim();

    if (value.includes('-')) {
      let [minValue, maxValue] = value.split('-').map(v => v.trim());

      // Clean numbers
      minValue = minValue.replace(currencySymbol, '').replace(/,/g, '');
      maxValue = maxValue.replace(currencySymbol, '').replace(/,/g, '');

      let formatted = '';

      if (minValue === '0') {
        // Case: "0-49"
        formatted = `${currencySymbol}${maxValue} and less`;
      } else if (maxValue === '*' || maxValue === '') {
        // Case: "2000-*"
        formatted = `${currencySymbol}${minValue} and more`;
      } else {
        // Case: "400-599"
        formatted = `${currencySymbol}${minValue} to ${currencySymbol}${maxValue}`;
      }

      // Replace only the text, preserve the "Price :" label span if it exists
      const labelSpan = item.querySelector('.facet-item-label-value-id');
      if (labelSpan) {
        // clear out everything after the label and insert our formatted value
        labelSpan.nextSibling && labelSpan.parentNode.removeChild(labelSpan.nextSibling);
        labelSpan.insertAdjacentText('afterend', ' ' + formatted);
      } else {
        // if no label span exists, just replace the content
        item.textContent = formatted;
      }
    }
  });
}

function formatSelectedSizeRangeLabels() {
  const facetItems = document.querySelectorAll(
    '.wizzy-selected-facet-list .wizzy-selected-facet-list-item[data-facetkey="product_thickness_new"]'
  );

  facetItems.forEach(item => {
    const facetKey = item.getAttribute('data-facetkey');
    const valueNode = item.querySelector('.facet-item-label-value');
    if (!valueNode) return;

    let rawText = valueNode.textContent.trim();
    rawText = rawText.replace(/^Width\s*:|^Length\s*:|^Thickness\s*:/i, '').trim();

    if (rawText.includes("to")) return;

    let formatted = '';

    // Find the matching slider on page
    const slider = document.querySelector(
      `.wizzy-facet-body.facet-body-${facetKey} .wizzy-facet-range-slider`
    );
    const sliderRange = slider?.noUiSlider?.options?.range || {};
    const minRange = parseFloat(sliderRange.min || 0);
    const maxRange = parseFloat(sliderRange.max || 0);

    if (rawText.includes('-')) {
      // Case: "50 - 144"
      let [minVal, maxVal] = rawText.split('-').map(v => parseFloat(v.replace(/[$]/g, '').trim()));
      if (!isNaN(minVal) && !isNaN(maxVal)) {
        formatted = `${formatInchesToFeetInches(facetKey, minVal)} to ${formatInchesToFeetInches(facetKey, maxVal)}`;
      }
    } else if (rawText.startsWith('<')) {
      // Case: "< 135"
      const upper = parseFloat(rawText.replace(/[^\d.]/g, ''));
      if (!isNaN(upper)) {
        formatted = `${formatInchesToFeetInches(facetKey, minRange)} to ${formatInchesToFeetInches(facetKey, upper)}`;
      }
    } else if (rawText.startsWith('>')) {
      // Case: "> 63"
      const lower = parseFloat(rawText.replace(/[^\d.]/g, ''));
      if (!isNaN(lower)) {
        formatted = `${formatInchesToFeetInches(facetKey, lower)} to ${formatInchesToFeetInches(facetKey, maxRange)}`;
      }
    }

    // Replace DOM text while keeping "Width :" / "Length :" intact
    const labelSpan = valueNode.querySelector('.facet-item-label-value-id');
    if (labelSpan) {
      labelSpan.nextSibling && labelSpan.parentNode.removeChild(labelSpan.nextSibling);
      labelSpan.insertAdjacentText('afterend', ' ' + formatted);
    } else {
      valueNode.textContent = formatted;
    }
  });
}


function updateNoUiSliderForSize(slider, facetKey) {
  slider.noUiSlider.updateOptions({
    tooltips: [
      {
        to: value => formatInchesToFeetInches(facetKey, value),
        from: value => parseFloat(value) // ensure slider parses numbers correctly
      },
      {
        to: value => formatInchesToFeetInches(facetKey, value),
        from: value => parseFloat(value)
      }
    ]
  }, true);
}

function formatInchesToFeetInches(facetKey, value) {
  value = parseFloat(value);
  if (isNaN(value)) return '';

  if (facetKey === 'product_thickness_new') {
    value = value/100;
    return `${value.toFixed(2)}"`;
  }

  const feet = Math.floor(value / 12);
  const inches = Math.round(value % 12);

  if (feet && inches) {
    return `${feet}' ${inches}"`;
  } else if (feet) {
    return `${feet}'`;
  } else {
    return `${inches}"`;
  }
}

function renderStars(rating) {
  const fullStars = parseInt(rating, 10);
  const emptyStars = 5 - fullStars;

  const filled = `
    <span class="icon icon-star-filled">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8617 1L14.4264 8.89151H22.7235L16.0109 13.7685L18.5743 21.66L11.8617 16.783L5.14919 21.66L7.71255 13.7685L1 8.89151H9.29703L11.8617 1Z" fill="currentColor" stroke="currentColor" stroke-width="0.872727" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"></path>
      </svg>
    </span>`.repeat(fullStars);

  const empty = `
    <span class="icon icon-star-empty">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8617 1L14.4264 8.89151H22.7235L16.0109 13.7685L18.5743 21.66L11.8617 16.783L5.14919 21.66L7.71255 13.7685L1 8.89151H9.29703L11.8617 1Z" stroke="currentColor" stroke-width="0.872727" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"></path>
      </svg>
    </span>`.repeat(emptyStars);

  return filled + empty;
}

function replaceReviewFacetLabels() {
  document.querySelectorAll('.wizzy-search-wrapper .wizzy-search-filters-left .wizzy-facet-body.facet-body-product_review_rating .wizzy-facet-list-item')
    .forEach(item => {
      const valueNode = item.querySelector('.facet-item-label-value');
      if (!valueNode) return;

      const rating = parseInt(valueNode.textContent.trim(), 10);
      if (!isNaN(rating) && rating >= 1 && rating <= 5) {
        valueNode.innerHTML = renderStars(rating);
      }
    });
}

function replaceSelectedReviewFacetLabels() {
  document.querySelectorAll('.wizzy-selected-facet-list .wizzy-selected-facet-list-item[data-facetkey="product_review_rating"]')
    .forEach(item => {
      const valueNode = item.querySelector('.facet-item-label-value');
      if (!valueNode) return;

      // Extract rating number (text after "Average Review :")
      const textContent = valueNode.textContent.trim();
      const match = textContent.match(/(\d+)/); // find first number
      if (!match) return;

      const rating = parseInt(match[1], 10);

      if (!isNaN(rating) && rating >= 1 && rating <= 5) {
        const labelId = valueNode.querySelector('.facet-item-label-value-id');
        const labelPrefix = labelId ? labelId.outerHTML + ' ' : '';

        valueNode.innerHTML = `${labelPrefix}${renderStars(rating)}`;
      }
    });
}

function handleInStockBtnOnClick() {
  var instockBtn = document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block.collapsible .wizzy-facet-head.facet-head-inStock .wizzy-facet-inStock-checkbox');

  if (instockBtn) {
    instockBtn.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var inStockLI = document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left .wizzy-facet-body.facet-body-inStock .wizzy-facet-list .wizzy-facet-list-item[data-key="_true"]');

      if (inStockLI) {
        inStockLI.click();
        var checkedAttribute = instockBtn.getAttribute("checked");
        if (checkedAttribute) {
          instockBtn.setAttribute("checked", false);
          window.wizzyShowOnlyInstock = false;
        } else {
          instockBtn.setAttribute("checked", true);
          window.wizzyShowOnlyInstock = true;
        }
      }
    })
  }
}

function handleInStockBtnAfterClick() {
  var instockValue = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.inStock;
  // console.log("BEFORE_RENDER_INSTOCK", instockValue);
  if (instockValue) {
    if (instockValue[0] === "true") {
      // console.log("BEFORE_RENDER_INSTOCKCHECK", instockValue);
      var inputForInstock = document.querySelector('.wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block.collapsible .wizzy-facet-head.facet-head-inStock .wizzy-facet-inStock-checkbox');
      if (inputForInstock) {
        inputForInstock.setAttribute("checked", ""); 
      }
    }
  }
}

function showFilterTooltip() {
  var filters = document.querySelectorAll('.wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block');
  filters.forEach((filter) => {
    var key = filter.getAttribute("data-key");
    var tooltipText = filterTooltips[key];

    const indicator = filter.querySelector(".wizzy-tooltip");
    const tooltip = filter.querySelector(".wizzy-tooltip-content");

    if (!tooltipText) {
      // no tooltip available → hide indicator
      indicator.style.display = "none";
      return;
    }

    tooltip.innerHTML = '';
    tooltip.innerHTML = tooltipText;
  });
}

function hideBeforeSearchIconIfEmpty() {
  const wrappers = document.querySelectorAll('.wizzy-search-wrapper .wizzy-search-filters-left .facet-search-wrapper');

  wrappers.forEach(wrapper => {
    if (wrapper.innerHTML.trim() === '') {
      wrapper.classList.add('empty-wrapper');
    } else {
      wrapper.classList.remove('empty-wrapper');
    }
  });
}

function handleScrollToTopButton() {
  let scrollToTopBtn = document.querySelector(
    "main .wizzy-scroll-to-top-wrapper"
  );

  if (scrollToTopBtn) {
    window.onscroll = function () {
      scrollFunction();
    };
    function scrollFunction() {
      if (
        document.body.scrollTop > 400 ||
        document.documentElement.scrollTop > 400
      ) {
        scrollToTopBtn.style.display = "block";
      } else {
        scrollToTopBtn.style.display = "none";
      }
    }
  }
}

// Size Filter - Length-Width Change - 17/08/26
// (#1 - solution) Additional Filter API — runs in parallel with main Filter (2 calls total).
// When this returns after main has already rendered, late-apply updates pageStore + facet DOM.
function fetchSellingPriceRangeAndSizes(data, generation) {
  const updatedFilters = {
    ...data.filters,
    facets: [
      {
        label: "Price",
        key: "sellingPrice",
        position: "left",
        order: 1
      },
      {
        label: "Sizes",
        key: "product_size_new",
        position: "left",
        order: 2
      },
      {
        label: "Shapes",
        key: "product_shape_new",
        position: "left",
        order: 3
      },
      {
        label: "All Sizes",
        key: "sizes",
        position: "left",
        order: 4
      }
    ],
    sort: [],
    getAllVariants: "true",
    productsCount: 1,
    attributeFacetValuesLimit: 100
  };

  const headers = {
    'x-store-id': '1b86d81c7e5311f0b4d70a0c8095feae',
    'x-api-key': 'YkttQXdsbUVzbzJkZzBDdHdEVnZ3Q3dDNmRyMkxaeHR2dTd4cFdqaEdpVjlTN2pyN2pBczNQcnhnLzdzdVB1aWtOU1JwQzZkS1k4SVpackhEc3dBWFY2V3p6MFJVUXlYQTFsdkJiaCtQckk9',
    'Content-Type': 'application/json;charset=UTF-8',
    'Accept': 'application/json, text/plain, */*'
  };

  const requestBody = {
    "filters": JSON.stringify(updatedFilters),
    "group": "page"
  };

  // (#1 - solution) Abort any previous in-flight additional Filter call.
  if (variantFacetsFetchController) {
    try {
      variantFacetsFetchController.abort();
    } catch (e) {
      // no-op
    }
  }
  variantFacetsFetchController = new AbortController();

  fetch("https://uranus-api.wizsearch.in/v1/products/filter", {
    method: "POST",
    headers: headers,
    body: JSON.stringify(requestBody),
    signal: variantFacetsFetchController.signal
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error("HTTP error! status: " + response.status);
      }
      return response.json();
    })
    .then(function (responseData) {
      // console.log("API Response:", data);
      // (#1 - solution) Ignore stale responses from older filter applies.
      if (generation !== variantFacetsFetchGeneration) {
        return;
      }

      const facets = responseData?.payload?.facets || [];

      priceRange = null;
      filteredSizes = null;
      filteredNormalizedSizes = null;
      filteredShapes = null;

      facets.forEach(function (facet) {
        if (!facet || !facet.key) {
          return;
        }

        switch (facet.key) {
          case "sellingPrice":
            priceRange = facet.data;
            break;

          case "sizes":
            filteredSizes = facet.data;
            break;

          case "product_size_new":
            filteredNormalizedSizes = facet.data;
            break;

          case "product_shape_new":
            filteredShapes = facet.data;
            break;
        }
      });

      variantFacetsDataGeneration = generation;

      // (#1 - solution) Late path: main UI may already be rendered — patch store + DOM now.
      applyLateVariantFacetsIfReady();
    })
    .catch(function (error) {
      if (error && error.name === "AbortError") {
        return;
      }
      console.error("Error calling the filter API:", error);
    });
}

// (#1 - solution) True when additional Filter data matches the latest dimension-filter request.
function hasFreshVariantFacetData() {
  return (
    variantFacetsDataGeneration > 0 &&
    variantFacetsDataGeneration === variantFacetsFetchGeneration &&
    (filteredSizes || filteredNormalizedSizes || filteredShapes || priceRange)
  );
}

// (#1 - solution) Replace variant-dependent facet entries on a Wizzy payload/pageStore facets collection.
function applyVariantFacetDataToFacets(facets) {
  if (!facets) {
    return facets;
  }

  var replacements = {
    sellingPrice: priceRange,
    sizes: filteredSizes,
    product_size_new: filteredNormalizedSizes,
    product_shape_new: filteredShapes
  };

  if (Array.isArray(facets)) {
    return facets.map(function (facet) {
      if (facet && replacements[facet.key]) {
        return Object.assign({}, facet, { data: replacements[facet.key] });
      }
      return facet;
    });
  }

  if (typeof facets === "object") {
    Object.keys(replacements).forEach(function (key) {
      if (replacements[key] && facets[key]) {
        facets[key] = Object.assign({}, facets[key], { data: replacements[key] });
      }
    });
  }

  return facets;
}

// (#1 - solution) Mutate main Filter payload facets before render (fast path).
function applyVariantFacetDataToPayload(payload) {
  if (!payload || !payload.facets) {
    return;
  }
  payload.facets = applyVariantFacetDataToFacets(payload.facets);
}

// (#1 - solution) Keep pageStore in sync so later Wizzy reads see variant facet values.
function applyVariantFacetDataToPageStore() {
  try {
    var store = window.wizzyConfig && window.wizzyConfig.pageStore;
    if (!store || !store.searchedResponse || !store.searchedResponse.facets) {
      return;
    }
    store.searchedResponse.facets = applyVariantFacetDataToFacets(
      store.searchedResponse.facets
    );
  } catch (e) {
    // no-op
  }
}

// (#1 - solution) Escape helpers for safe facet list HTML rebuild.
function escapeFacetAttr(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function escapeFacetHtml(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

// (#1 - solution) Mirror BEFORE_RENDER_RESULTS size ordering for late DOM rebuilds.
function normalizeSizesFacetDataForDisplay(sizes) {
  if (!Array.isArray(sizes)) {
    return [];
  }

  var preferredOrder = [
    "2' x 3'",
    "3' x 5'",
    "4' x 6'",
    "5' x 8'",
    "6' Runner",
    "6' Round",
    "6' Square",
    "6' x 9'",
    "8' Runner",
    "8' Round",
    "8' Square",
    "8' x 10'",
    "8' x 11'",
    "9' x 12'",
    "10' Runner",
    "10'+ Round",
    "10'+ Square",
    "10' x 14'",
    "12' x 15'+",
    "12'+ Runner",
    "Custom Size"
  ];

  var ordered = [];
  for (var j = 0; j < preferredOrder.length; j++) {
    for (var k = 0; k < sizes.length; k++) {
      if (sizes[k].key == preferredOrder[j]) {
        ordered.push(sizes[k]);
      }
    }
  }
  return ordered.length ? ordered : sizes.slice();
}

// (#1 - solution) Mirror BEFORE_RENDER_RESULTS shape allow-list for late DOM rebuilds.
function normalizeShapesFacetDataForDisplay(shapes) {
  if (!Array.isArray(shapes)) {
    return [];
  }

  var allowedShapeFacets = ["rectangle", "round", "square", "runner"];
  return shapes.filter(function (item) {
    var key = (item.key || "").trim().toLowerCase();
    return allowedShapeFacets.indexOf(key) !== -1;
  });
}

// (#1 - solution) Build a single common facet list item matching Wizzy's default markup.
function buildFacetListItemHtml(item) {
  var key = item.key || "";
  var label = item.label || item.key || "";
  var count = item.count != null ? item.count : 0;
  var isSelected = !!item.isSelected;

  return (
    '<li class="wizzy-facet-list-item' +
    (isSelected ? " active" : "") +
    '" data-key="' +
    escapeFacetAttr(key) +
    '" data-term="' +
    escapeFacetAttr(label) +
    '" title="' +
    escapeFacetAttr(label) +
    '">' +
    '<span class="wizzy-facet-list-item-label">' +
    '<span class="wizzy-facet-list-item-checkbox">' +
    '<input type="checkbox" class="wizzy-facet-list-item-checkbox-input"' +
    (isSelected ? " checked" : "") +
    " />" +
    '<div class="checkbox-indicator"></div>' +
    "</span>" +
    '<span class="facet-item-label-value">' +
    escapeFacetHtml(label) +
    "</span>" +
    "</span>" +
    '<span class="wizzy-facet-list-item-count">(' +
    count +
    ")</span>" +
    "</li>"
  );
}

// (#1 - solution) Ensure a facet block + list exist (sizes may be hidden / missing when empty).
function ensureFacetListElement(facetKey) {
  var blockSelector =
    '.wizzy-filters-facet-block.facet-block-' + facetKey;
  var block = document.querySelector(blockSelector);

  if (!block) {
    var filtersLeft = document.querySelector(
      ".wizzy-search-wrapper .wizzy-search-filters-left"
    );
    if (!filtersLeft) {
      return null;
    }

    block = document.createElement("div");
    block.className =
      "wizzy-filters-facet-block facet-block-" +
      facetKey +
      " facet-block-left";
    block.setAttribute("data-key", facetKey);
    if (facetKey === "sizes") {
      block.style.display = "none";
    }

    var body = document.createElement("div");
    body.className = "wizzy-facet-body facet-body-" + facetKey;

    var list = document.createElement("ul");
    list.className = "wizzy-facet-list";

    body.appendChild(list);
    block.appendChild(body);
    filtersLeft.appendChild(block);
    return list;
  }

  var listEl = block.querySelector(".wizzy-facet-list");
  if (!listEl) {
    var bodyEl = block.querySelector(".wizzy-facet-body");
    if (!bodyEl) {
      bodyEl = document.createElement("div");
      bodyEl.className = "wizzy-facet-body facet-body-" + facetKey;
      block.appendChild(bodyEl);
    }
    listEl = document.createElement("ul");
    listEl.className = "wizzy-facet-list";
    bodyEl.appendChild(listEl);
  }

  return listEl;
}

// (#1 - solution) Replace facet list DOM items with variant-level values.
function rebuildFacetListDom(facetKey, facetData) {
  if (!facetData || !Array.isArray(facetData)) {
    return false;
  }

  var listEl = ensureFacetListElement(facetKey);
  if (!listEl) {
    return false;
  }

  var html = "";
  for (var i = 0; i < facetData.length; i++) {
    html += buildFacetListItemHtml(facetData[i]);
  }
  listEl.innerHTML = html;
  return true;
}

// (#1 - solution) Late path entry: patch pageStore + facet DOM + rebuild length/width dropdowns.
// Safe to call from additional API .then and from VIEW_RENDERED / cached render hooks.
function applyLateVariantFacetsIfReady() {
  if (!hasFreshVariantFacetData()) {
    return;
  }

  if (variantFacetsDomAppliedGeneration === variantFacetsDataGeneration) {
    return;
  }

  applyVariantFacetDataToPageStore();

  // (#1 - solution) Wait until Wizzy has rendered the filters DOM before rebuilding lists.
  var filtersReady = !!document.querySelector(
    ".wizzy-search-wrapper .wizzy-search-filters-left"
  );
  if (!filtersReady) {
    return;
  }

  if (filteredSizes) {
    rebuildFacetListDom("sizes", filteredSizes);
  }

  if (filteredNormalizedSizes) {
    rebuildFacetListDom(
      "product_size_new",
      normalizeSizesFacetDataForDisplay(filteredNormalizedSizes)
    );
  }

  if (filteredShapes) {
    rebuildFacetListDom(
      "product_shape_new",
      normalizeShapesFacetDataForDisplay(filteredShapes)
    );
  }

  // Recreate length/width dropdowns from the updated sizes facet list.
  var sizeBody = document.querySelector(
    ".wizzy-filters-facet-block.facet-block-product_size_new .wizzy-facet-body.facet-body-product_size_new"
  );
  if (sizeBody) {
    var existingDropdowns = sizeBody.querySelector(
      ".wizzy-product-size-dropdowns"
    );
    if (existingDropdowns) {
      existingDropdowns.remove();
    }
  }

  createProductSizeDropdowns();
  preselectProductSizeDropdownsFromURL();
  updateProductSizeSelectedFilterLabels();
  initializeProductSizeSelectedFilterRemoval();
  initializeProductSizeClearAll();

  variantFacetsDomAppliedGeneration = variantFacetsDataGeneration;
}

function attachSliderTooltipGuard(sliderSelector) {

    var slider = document.querySelector(sliderSelector);
    if (!slider || !slider.noUiSlider) return;

    slider.noUiSlider.on('update', function () {

        requestAnimationFrame(() => {

            var sliderRect = slider.getBoundingClientRect();

            /* ========== UPPER HANDLE (left overflow protection) ========== */

            var upperHandle = slider.querySelector('.noUi-handle-upper');
            if (upperHandle) {

                var upperTooltip = upperHandle.querySelector('.noUi-tooltip');
                if (upperTooltip) {

                    var upperHandleRect = upperHandle.getBoundingClientRect();
                    var upperTooltipWidth = upperTooltip.offsetWidth;

                    var expectedLeft = upperHandleRect.left - upperTooltipWidth;

                    if (expectedLeft < sliderRect.left) {
                        upperTooltip.classList.add('pinned-left');
                    } else {
                        upperTooltip.classList.remove('pinned-left');
                    }
                }
            }

            /* ========== LOWER HANDLE (right overflow protection) ========== */

            var lowerHandle = slider.querySelector('.noUi-handle-lower');
            if (lowerHandle) {

                var lowerTooltip = lowerHandle.querySelector('.noUi-tooltip');
                if (lowerTooltip) {

                    var lowerHandleRect = lowerHandle.getBoundingClientRect();
                    var lowerTooltipWidth = lowerTooltip.offsetWidth;

                    // Natural right edge if centered
                    var expectedRight =
                        lowerHandleRect.left + lowerTooltipWidth;

                    if (expectedRight > sliderRect.right) {
                        lowerTooltip.classList.add('pinned-right');
                    } else {
                        lowerTooltip.classList.remove('pinned-right');
                    }
                }
            }

        });

    });
}

function pluralizeSelectedColorFacets() {

    document.querySelectorAll(
        '.wizzy-selected-facet-list-item[data-facetkey="product_new_primary_colors"]'
    ).forEach(function (item) {

        var label = item.querySelector('.facet-item-label-value');
        if (!label) return;

        var term = item.getAttribute('data-term');
        if (!term) return;

        var isVowelY = /[aeiou]y$/i.test(term);

        // Always compute from original source
        var plural = term.toLowerCase().endsWith('y')
            ? (isVowelY ? term + 's' : term.slice(0, -1) + 'ies')
            : term + 's';

        // Find the actual color text node (ignore whitespace)
        var textNode = Array.from(label.childNodes)
            .reverse()
            .find(node =>
                node.nodeType === 3 &&
                node.textContent.trim() !== ''
            );

        if (!textNode) return;

        // Only update if needed (prevents unnecessary DOM writes)
        if (textNode.textContent.trim() !== plural) {
            textNode.textContent = ' ' + plural + ' ';
        }

    });
}

// Size Filter - Length-Width Change - 17/08/26
function createProductSizeDropdowns() {
    var targetContainer = document.querySelector(
      '.wizzy-filters-facet-block.facet-block-product_size_new .wizzy-facet-body.facet-body-product_size_new'
    );

    if (!targetContainer) {
      return;
    }

    var sourceItems = document.querySelectorAll(
      '.wizzy-filters-facet-block.facet-block-sizes .wizzy-facet-list-item'
    );

    if (!sourceItems.length) {
      return;
    }

    var widths = [];
    var lengths = [];

    function dimensionToInches(value) {
      value = value.trim();

      var feetMatch = value.match(/(\d+(?:\.\d+)?)\s*['′]/);
      var inchesMatch = value.match(/(\d+(?:\.\d+)?)\s*(?:["″]|'')/);

      var feet = feetMatch ? parseFloat(feetMatch[1]) : 0;
      var inches = inchesMatch ? parseFloat(inchesMatch[1]) : 0;

      if (!feetMatch && !inchesMatch) {
        var numericValue = parseFloat(value);

        return isNaN(numericValue) ? null : numericValue;
      }

      return (feet * 12) + inches;
    }

    function addUniqueValue(array, value) {
        if (value === null || isNaN(value)) {
          return;
        }

        if (array.indexOf(value) === -1) {
          array.push(value);
        }
    }

    function formatDimension(inches) {
      var feet = Math.floor(inches / 12);
      var remainingInches = inches % 12;

      if (remainingInches === 0) {
        return feet + "'";
      }

      return feet + "' " + remainingInches + "''";
    }

    function createSelect(className, placeholderText, values) {
      var select = document.createElement('select');

      select.className = className;

      var placeholder = document.createElement('option');

      placeholder.value = '';
      placeholder.textContent = placeholderText;
      placeholder.disabled = true;
      placeholder.selected = true;

      select.appendChild(placeholder);

      values.forEach(function (value) {
        var option = document.createElement('option');

        option.value = value;
        option.textContent = formatDimension(value);

        select.appendChild(option);
      });

      return select;
    }

  sourceItems.forEach(function (item) {
      var labelElement = item.querySelector(
        '.facet-item-label-value'
      );

      if (!labelElement) {
        return;
      }

      var size = labelElement.textContent.trim();

      var dimensions = size
        .replace(
          /\s+(Rectangle|Round|Square|Oval|Free-Form|Runner|Octagon|Basket|Half Moon|Specialty)\s*$/i,
          ''
        )
        .trim();

      var parts = dimensions.split(/\s*[xX]\s*/);

      var widthValue = parts[0]
        ? parts[0].trim()
        : '';

      var lengthValue = parts[1]
        ? parts[1].trim()
        : '';

      var widthInches = dimensionToInches(widthValue);

      if (widthInches === null) {
        return;
      }

      var lengthInches;

      if (parts.length > 1 && lengthValue) {
        lengthInches = dimensionToInches(lengthValue);
      } else {
        lengthInches = widthInches;
      }

      if (lengthInches === null) {
        lengthInches = widthInches;
      }

      addUniqueValue(widths, widthInches);
      addUniqueValue(lengths, lengthInches);
    });

    /*
     * Sort numerically in ascending order.
     */
    widths.sort(function (a, b) {
      return a - b;
    });

    lengths.sort(function (a, b) {
      return a - b;
    });

    /*
     * Main wrapper.
     */
    var dropdownWrapper = document.createElement('div');

    dropdownWrapper.className =
      'wizzy-product-size-dropdowns';

    /*
     * Helper to create a dropdown + clear button.
     */
    function createSizeControl(
      type,
      labelText,
      placeholderText,
      selectClass,
      values,
      filterKey
    ) {
      var wrapper = document.createElement('div');

      wrapper.className =
        'wizzy-product-size-dropdown ' +
        type + '-dropdown';

      var labelWrapper = document.createElement('div');

      labelWrapper.className =
        'wizzy-product-size-dropdown-label';

      var label = document.createElement('label');

      label.textContent = labelText;

      var clearButton = document.createElement('button');

      clearButton.type = 'button';
      clearButton.className = 'wizzy-product-size-clear';
      clearButton.textContent = 'Clear';
      clearButton.style.display = 'none';

      var select = createSelect(
        selectClass,
        placeholderText,
        values
      );

      select.addEventListener('change', function () {
        clearButton.style.display =
          this.value ? 'inline-flex' : 'none';

        handleProductSizeFilterChange(
          this,
          filterKey
        );
      });

      clearButton.addEventListener('click', function () {
        clearProductSizeFilter(
          select,
          clearButton,
          filterKey
        );
      });

      labelWrapper.appendChild(label);
      labelWrapper.appendChild(clearButton);

      wrapper.appendChild(labelWrapper);
      wrapper.appendChild(select);

      return wrapper;
    }

    /*
     * WIDTH
     */
    var widthWrapper = createSizeControl(
      'width',
      'Width',
      'Select Width',
      'wizzy-product-size-width-select',
      widths,
      'product_width_new'
    );

    /*
     * LENGTH
     */
    var lengthWrapper = createSizeControl(
      'length',
      'Length',
      'Select Length',
      'wizzy-product-size-length-select',
      lengths,
      'product_length_new'
    );

    dropdownWrapper.appendChild(widthWrapper);
    dropdownWrapper.appendChild(lengthWrapper);

    /*
     * Only append once.
     */
    var existingDropdowns = targetContainer.querySelector(
      '.wizzy-product-size-dropdowns'
    );

    if (!existingDropdowns) {
      targetContainer.appendChild(dropdownWrapper);
    }
}

function handleProductSizeFilterChange(selectElement, filterKey) {
  if (!selectElement || !selectElement.value) {
    return;
  }

  try {
    var selectedValue = parseFloat(selectElement.value);

    if (isNaN(selectedValue)) {
      return;
    }

    var currentUrl = new URL(window.location.href);
    var params = currentUrl.searchParams;

    var lteKey = 'fA.' + filterKey + '.lte[]';
    var gteKey = 'fA.' + filterKey + '.gte[]';

    /*
      * The corresponding normal filter parameter.
      *
      * Example:
      * product_width_new[]=
      * product_length_new[]=
      */
    var selectedFilterKey = filterKey + '[]';

    /*
      * Remove the existing values for this particular filter
      * before adding the newly selected range.
      */
    params.delete(lteKey);
    params.delete(gteKey);
    params.delete(selectedFilterKey);

    /*
      * Calculate the ±6 inches range.
      *
      * Example:
      * Selected value = 30
      *
      * gte = 30 - 6 = 24
      * lte = 30 + 6 = 36
      */
    var gteValue = selectedValue - 6;
    var lteValue = selectedValue + 6;

    params.append(
      lteKey,
      lteValue.toFixed(2)
    );

    params.append(
      gteKey,
      gteValue.toFixed(2)
    );

    /*
      * Add the corresponding normal filter parameter
      * with an empty value so Wizzy automatically renders
      * the filter in the selected filters section.
      *
      * Example:
      * product_width_new[]=
      *
      * or:
      * product_length_new[]=
      */
    params.append(
      selectedFilterKey,
      ''
    );

    /*
      * Rebuild the URL.
      */
    var newUrl =
      currentUrl.origin +
      currentUrl.pathname +
      '?' +
      params.toString();

    /*
      * Convert [] back from URL encoded form.
      */
    newUrl = newUrl.replace(
      /%5B%5D/g,
      '[]'
    );

    /*
      * Execute Wizzy filters from the generated URL.
      */
    if (
      typeof window.executeWizzyFiltersFromURL ===
      'function'
    ) {
      setTimeout(function () {
        window.executeWizzyFiltersFromURL(
          newUrl
        );
      }, 500);
    } else {
      console.warn(
        '⚠️ WIZZY executeWizzyFiltersFromURL not found on window'
      );
    }
  } catch (err) {
    console.error(
      '❌ WIZZY Error while processing product size filter:',
      err
    );
  }
}

function preselectProductSizeDropdownsFromURL() {
  var currentUrl = new URL(window.location.href);
  var params = currentUrl.searchParams;

  function getSelectedValue(filterKey) {
    var gteKey = 'fA.' + filterKey + '.gte[]';
    var lteKey = 'fA.' + filterKey + '.lte[]';

    var gteValue = params.get(gteKey);
    var lteValue = params.get(lteKey);

    if (gteValue === null || lteValue === null) {
      return null;
    }

    gteValue = parseFloat(gteValue);
    lteValue = parseFloat(lteValue);

    if (isNaN(gteValue) || isNaN(lteValue)) {
      return null;
    }

    /*
      * The selected value is the midpoint of
      * the ±6 inches range.
      *
      * Example:
      * gte = 21
      * lte = 33
      *
      * selected = 27
      */
    return (gteValue + lteValue) / 2;
  }

  function selectMatchingOption(
    selectElement,
    selectedValue
  ) {
    if (!selectElement || selectedValue === null) {
      return;
    }

    var options = selectElement.options;

    for (var i = 0; i < options.length; i++) {
      var optionValue = parseFloat(
        options[i].value
      );

      if (isNaN(optionValue)) {
        continue;
      }

      if (
        Math.abs(
            optionValue - selectedValue
        ) < 0.01
      ) {
        selectElement.value =
          options[i].value;

        /*
          * Show the corresponding Clear button.
          */
        var clearButton =
          selectElement.parentElement.querySelector(
            '.wizzy-product-size-clear'
          );

        if (clearButton) {
          clearButton.style.display =
            'inline-flex';
        }

        return;
      }
    }
  }

  var widthSelect = document.querySelector(
    '.wizzy-product-size-width-select'
  );

  var lengthSelect = document.querySelector(
    '.wizzy-product-size-length-select'
  );

  /*
    * WIDTH
    */
  var widthValue = getSelectedValue(
    'product_width_new'
  );

  if (widthValue !== null) {
    // console.log(
    //   'WIZZY Preselect Width:',
    //   widthValue
    // );

    selectMatchingOption(
      widthSelect,
      widthValue
    );
  }

  /*
    * LENGTH
    */
  var lengthValue = getSelectedValue(
    'product_length_new'
  );

  if (lengthValue !== null) {
    // console.log(
    //   'WIZZY Preselect Length:',
    //   lengthValue
    // );

    selectMatchingOption(
      lengthSelect,
      lengthValue
    );
  }
}

function clearProductSizeFilter(
  selectElement,
  clearButton,
  filterKey
) {
  try {
    var currentUrl = new URL(window.location.href);
    var params = currentUrl.searchParams;

    var gteKey = 'fA.' + filterKey + '.gte[]';
    var lteKey = 'fA.' + filterKey + '.lte[]';

    /*
      * Remove only the selected size filter.
      */
    params.delete(gteKey);
    params.delete(lteKey);

    /*
      * Clear the dropdown UI.
      */
    selectElement.value = '';

    /*
      * Hide Clear button.
      */
    clearButton.style.display = 'none';

    /*
      * Rebuild URL.
      */
    var newUrl =
      currentUrl.origin +
      currentUrl.pathname +
      '?' +
      params.toString();

    newUrl = newUrl.replace(
      /%5B%5D/g,
      '[]'
    );

    // console.log(
    //   '🧹 WIZZY Cleared product size filter:',
    //   filterKey
    // );

    // console.log(
    //   '🟢 WIZZY New URL after clearing:',
    //   newUrl
    // );

    /*
      * Execute Wizzy filters.
      */
    if (
      typeof window.executeWizzyFiltersFromURL ===
      'function'
    ) {
      setTimeout(function () {
        // console.log(
        //   '🚀 WIZZY Calling executeWizzyFiltersFromURL after clear...'
        // );

        window.executeWizzyFiltersFromURL(
          newUrl
        );
      }, 500);
    } else {
      console.warn(
        '⚠️ WIZZY executeWizzyFiltersFromURL not found on window'
      );
    }
  } catch (err) {
    console.error(
      '❌ WIZZY Error while clearing product size filter:',
      err
    );
  }
}

function updateProductSizeSelectedFilterLabels() {
  var selectedFilters = document.querySelectorAll(
    '.wizzy-selected-facet-list-item[data-facetkey="product_width_new"], ' +
    '.wizzy-selected-facet-list-item[data-facetkey="product_length_new"]'
  );

  if (!selectedFilters.length) {
    return;
  }

  var currentUrl = new URL(window.location.href);
  var params = currentUrl.searchParams;

  function getSelectedValue(filterKey) {
    var gteKey = 'fA.' + filterKey + '.gte[]';
    var lteKey = 'fA.' + filterKey + '.lte[]';

    var gteValue = params.get(gteKey);
    var lteValue = params.get(lteKey);

    if (
      gteValue === null ||
      lteValue === null
    ) {
      return null;
    }

    gteValue = parseFloat(gteValue);
    lteValue = parseFloat(lteValue);

    if (
      isNaN(gteValue) ||
      isNaN(lteValue)
    ) {
      return null;
    }

    /*
      * The selected value is the midpoint
      * of the ±6 inches range.
      */
    return (gteValue + lteValue) / 2;
  }

  function formatDimension(inches) {
    var feet = Math.floor(inches / 12);
    var remainingInches = inches % 12;

    remainingInches =
      Math.round(remainingInches * 100) / 100;

    if (remainingInches === 0) {
      return feet + "'";
    }

    return feet + "' " + remainingInches + "''";
  }

  selectedFilters.forEach(function (filter) {
    var filterKey =
      filter.getAttribute('data-facetkey');

    var selectedValue =
      getSelectedValue(filterKey);

    if (selectedValue === null) {
      return;
    }

    var labelValue =
      filter.querySelector(
        '.facet-item-label-value'
      );

    if (!labelValue) {
      return;
    }

    /*
      * Find the existing "Width :" / "Length :"
      * element generated by Wizzy.
      */
    var labelId =
      labelValue.querySelector(
        '.facet-item-label-value-id'
      );

    if (!labelId) {
      return;
    }

    /*
      * Remove only the text after the label element.
      * This keeps Wizzy's existing HTML structure intact.
      */
    Array.prototype.slice.call(
      labelValue.childNodes
    ).forEach(function (node) {
      if (node !== labelId) {
        labelValue.removeChild(node);
      }
    });

    /*
      * Add our actual selected size instead of
      * Wizzy's generated price/range value.
      */
    labelValue.appendChild(
      document.createTextNode(
        ' ' + formatDimension(selectedValue)
      )
    );

    /*
      * Update the attributes as well.
      */
    filter.setAttribute(
      'data-term',
      formatDimension(selectedValue)
    );

    filter.setAttribute(
      'title',
      formatDimension(selectedValue)
    );
  });
}

function initializeProductSizeSelectedFilterRemoval() {
  var selectedFilters = document.querySelectorAll(
    '.wizzy-selected-facet-list-item[data-facetkey="product_width_new"], ' +
    '.wizzy-selected-facet-list-item[data-facetkey="product_length_new"]'
  );

  if (!selectedFilters.length) {
    return;
  }

  selectedFilters.forEach(function (filter) {
    /*
      * Prevent duplicate event binding when
      * Wizzy triggers the function multiple times.
      */
    if (
      filter.getAttribute(
        'data-product-size-remove-bound'
      ) === 'true'
    ) {
      return;
    }

    filter.setAttribute(
      'data-product-size-remove-bound',
      'true'
    );

    /*
      * Width and Length are treated as one logical filter.
      * Clicking either selected filter removes both.
      */
    filter.addEventListener(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        clearProductSizeSelectedFilter();
      }
    );
  });
}

function clearProductSizeSelectedFilter() {
  try {
    var currentUrl =
      new URL(window.location.href);

    var params =
      currentUrl.searchParams;

    /*
      * Remove WIDTH range parameters.
      */
    params.delete(
      'fA.product_width_new.gte[]'
    );

    params.delete(
      'fA.product_width_new.lte[]'
    );

    /*
      * Remove WIDTH direct filter parameter.
      */
    params.delete(
      'product_width_new[]'
    );

    /*
      * Remove LENGTH range parameters.
      */
    params.delete(
      'fA.product_length_new.gte[]'
    );

    params.delete(
      'fA.product_length_new.lte[]'
    );

    /*
      * Remove LENGTH direct filter parameter.
      */
    params.delete(
      'product_length_new[]'
    );

    /*
      * Rebuild the URL while keeping
      * every other filter/parameter unchanged.
      */
    var newUrl =
      currentUrl.origin +
      currentUrl.pathname +
      '?' +
      params.toString();

    /*
      * Convert [] back from URL encoded form.
      */
    newUrl = newUrl.replace(
      /%5B%5D/g,
      '[]'
    );

    console.log(
      '🧹 WIZZY Removing both Width and Length filters'
    );

    console.log(
      '🟢 WIZZY New URL:',
      newUrl
    );

    if (
      typeof window.executeWizzyFiltersFromURL ===
      'function'
    ) {
      setTimeout(function () {
        window.executeWizzyFiltersFromURL(
          newUrl
        );
      }, 500);
    } else {
      console.warn(
        '⚠️ WIZZY executeWizzyFiltersFromURL not found on window'
      );
    }
  } catch (err) {
    console.error(
      '❌ WIZZY Error while removing product size filters:',
      err
    );
  }
}

function initializeProductSizeClearAll() {
  var clearAllButton = document.querySelector(
    '.wizzy_filter-clear_button'
  );

  if (!clearAllButton) {
    return;
  }

  if (
    clearAllButton.getAttribute(
      'data-product-size-clear-all-bound'
    ) === 'true'
  ) {
    return;
  }

  clearAllButton.setAttribute(
    'data-product-size-clear-all-bound',
    'true'
  );

  // Capture phase: set flag before Start Over bubbles and triggers Wizzy clearAll,
  // so BEFORE_FILTERS can strip width/length float ranges from the cleared payload.
  clearAllButton.addEventListener(
    'click',
    function () {
      pendingClearProductSizeFloatFilters = true;
    },
    true
  );

  clearAllButton.addEventListener(
    'click',
    function () {
      /*
        * Wait for Wizzy's own Clear All logic
        * to remove the normal filter parameters.
        */
      setTimeout(function () {
        clearProductSizeFiltersFromURL();
      }, 100);
    }
  );
}

function clearProductSizeFiltersFromURL() {
  try {
    var currentUrl =
      new URL(window.location.href);

    var params =
      currentUrl.searchParams;

    /*
      * Remove WIDTH fA range parameters.
      */
    params.delete(
      'fA.product_width_new.gte[]'
    );

    params.delete(
      'fA.product_width_new.lte[]'
    );

    /*
      * Remove LENGTH fA range parameters.
      */
    params.delete(
      'fA.product_length_new.gte[]'
    );

    params.delete(
      'fA.product_length_new.lte[]'
    );

    // Also remove top-level chips / broken object encodings left after Clear All
    // (e.g. product_width_new[]=[object Object]).
    params.delete(
      'product_width_new[]'
    );
    params.delete(
      'product_length_new[]'
    );

    /*
      * Rebuild the URL while preserving
      * every other parameter.
      */
    var newUrl =
      currentUrl.origin +
      currentUrl.pathname +
      '?' +
      params.toString();

    /*
      * Convert [] back from URL encoded form.
      */
    newUrl = newUrl.replace(
      /%5B%5D/g,
      '[]'
    );

    console.log(
      '🧹 WIZZY Removed product size fA filters from Clear All'
    );

    console.log(
      '🟢 WIZZY New URL:',
      newUrl
    );

    /*
      * Update the browser URL without triggering
      * another filter execution.
      *
      * This should be called after Wizzy's Clear All
      * has removed the normal filters.
      */
    window.history.replaceState(
      {},
      '',
      newUrl
    );
  } catch (err) {
    console.error(
      '❌ WIZZY Error while clearing product size fA filters:',
      err
    );
  }
}

// --- Mapping --- Whenever a new Size and Shape is supposed to be added on frontend, Make sure to update the webhook logic of creating float attribute for size-shape combination price values

const SIZE_TO_SHAPE = {
  "2' x 3'": "Rectangle",
  "3' x 5'": "Rectangle",
  "4' x 6'": "Rectangle",
  "5' x 8'": "Rectangle",
  "6' x 9'": "Rectangle",
  "8' x 10'": "Rectangle",
  "8' x 11'": "Rectangle",
  "9' x 12'": "Rectangle",
  "10' x 14'": "Rectangle",
  "12' x 15'+": "Rectangle",

  "6' Runner": "Runner",
  "8' Runner": "Runner",
  "10' Runner": "Runner",
  "12'+ Runner": "Runner",

  "6' Round": "Round",
  "6' Square": "Square",
  "8' Round": "Round",
  "8' Square": "Square",
  "10'+ Round": "Round",
  "10'+ Square": "Square",
};

const SHAPE_TO_SIZES = {
  Rectangle: [
    "2' x 3'",
    "3' x 5'",
    "4' x 6'",
    "5' x 8'",
    "6' x 9'",
    "8' x 10'",
    "8' x 11'",
    "9' x 12'",
    "10' x 14'",
    "12' x 15'+",
  ],

  Runner: [
    "6' Runner",
    "8' Runner",
    "10' Runner",
    "12'+ Runner",
  ],

  Round: [
    "6' Round",
    "8' Round",
    "10'+ Round",
  ],

  Square: [
    "6' Square",
    "8' Square",
    "10'+ Square",
  ]
};





window.addEventListener("scroll", function(){
  var autoCompleteBodyWrapper = document.querySelector(".wizzy-body-end-wrapper");
  if (autoCompleteBodyWrapper) {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      autoCompleteBodyWrapper.classList.add("wizzy-autocomplete-wrapper-scrolled")
    } else {
      autoCompleteBodyWrapper.classList.remove("wizzy-autocomplete-wrapper-scrolled")
    }
  }
});  

document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.wizzy-search-input-form');
  const inputs = document.querySelectorAll('.wizzy_searchInput');

  // ---- CLEAR BUTTON HANDLING ----
  forms.forEach(form => {
    const input = form.querySelector('.wizzy_searchInput');
    const clearBtn = form.querySelector('.wizzy_search-box_clear');

    if (!input || !clearBtn) return;

    const toggleClear = () => {
      clearBtn.style.display = input.value && input.value.trim().length ? 'inline' : 'none';
    };

    // Initial check
    toggleClear();

    // Delayed re-check for mobile autofill (some browsers update value late)
    setTimeout(toggleClear, 300);

    // Handle typing
    input.addEventListener('input', toggleClear);

    // Handle clear button
    clearBtn.addEventListener('click', () => {
      input.value = '';
      toggleClear();
      input.focus();
    });
  });

  // ---- DESKTOP ↔ MOBILE SYNC ----
  setTimeout(function(){
    if (inputs.length > 1) {
        const desktopInput = inputs[0];
        const mobileInput = inputs[1];

        // Copy desktop value to mobile if mobile is empty
        if (desktopInput.value && !mobileInput.value) {
            mobileInput.value = desktopInput.value;
        }

        // Optional: keep in sync while typing
        desktopInput.addEventListener('input', () => {
            mobileInput.value = desktopInput.value;
        });
        mobileInput.addEventListener('input', () => {
            desktopInput.value = mobileInput.value;
        });
    }
  }, 200);
});

function makeArray(count) {
  return Array.from({ length: count }, () => ({}));
}

function isValidNumber(val) {
  return val !== null && val !== undefined && val !== "" && !isNaN(Number(val));
}


(function fixDoubleEncodedUrlForWizzyPages() {
  /**
   * Safely decode a value without throwing if not properly encoded
   */
  function safeDecode(value) {
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }

  /**
   * Fix double-encoded query params and restore readable [] syntax
   */
  function fixDoubleEncodedUrl(url) {
    try {
      const u = new URL(url);
      const fixedParams = new URLSearchParams();

      for (const [key, value] of u.searchParams.entries()) {
        const decodedKey = safeDecode(safeDecode(key));
        const decodedValue = safeDecode(safeDecode(value));
        fixedParams.append(decodedKey, decodedValue);
      }

      let finalUrl = `${u.origin}${u.pathname}`;
      const queryString = fixedParams.toString();

      if (queryString) {
        finalUrl += `?${queryString}`;
      }

      // Decode [] only
      finalUrl = finalUrl.replace(/%5B%5D/g, "[]");

      return finalUrl;
    } catch (err) {
      // console.error("⚠️ Wizzy URL fixer failed:", err);
      return url;
    }
  }

  // --- Run only for Wizzy-related query parameters ---
  const currentUrl = window.location.href;
  const searchParams = window.location.search;

  // Only execute if these patterns exist in the query string
  const wizzyIndicators = ["product_", "color_", "sellingPrice", "brands"];
  const isWizzyUrl = wizzyIndicators.some(param => searchParams.includes(param));

  if (!isWizzyUrl) {
    // Not a Wizzy page — skip
    return;
  }

  const fixedUrl = fixDoubleEncodedUrl(currentUrl);

  if (fixedUrl !== currentUrl) {
    // Update the URL silently (no reload)
    window.history.replaceState({}, "", fixedUrl);
    // console.log("✅ Wizzy URL auto-fixed:", fixedUrl);
  }
})();

if (window.location.href.includes('/collections/vendors')) {
  const url = new URL(window.location.href);
  const params = url.searchParams;

  // Take the first vendor value
  const vendor = params.get('product_vendor[]');

  if (vendor) {
    params.set('q', vendor);  // Add or replace the q param
    url.search = params.toString();

    // convert %5B%5D → [] for readability
    let cleanUrl = url.toString().replace(/%5B%5D/g, "[]");

    // update URL without reload
    window.history.replaceState({}, "", cleanUrl);
  }
}


